import React, { useState, useEffect, useRef } from "react";
import TaskListModal from "./TaskListModal";
import { useTheme } from "@mui/material/styles";
import {
  BASE_URL,
  BRANCH_AND_RO_LIST_BY_BDM,
  CHECK_IN,
  CHECK_OUT,
  GET_DETAILS_BY_MOBILE_NUMBER,
  GET_FARM_DATA,
  STATE_API,
  SUBMIT_ADD_OTHER_TASKS,
  SUBMIT_TO_DO_TASKS,
  VISIT_FORM_SUBMIT,
} from "../../constants";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import {
  Box,
  Button,
  Collapse,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
  useMediaQuery,
  Grid,
  TextField,
  Snackbar,
  Alert,
  InputAdornment,
  CircularProgress,
  Chip,
  Card,
  CardContent,
  Autocomplete,
  FormHelperText,
} from "@mui/material";
import {
  CircleCheck,
  Image,
  ImageIcon,
  Search,
  SearchIcon,
} from "lucide-react";
import axios from "axios";
import Loader from "../reusable Component/Loader";
import MeetingFormComponent from "../BDM Assigned Page/meetingForm";
import CloseIcon from "@mui/icons-material/Close";

import OnCallFormComponent from "../BDM Assigned Page/OnCallForm";
import SiteVisitFormComponent from "../BDM Assigned Page/siteVisitForm";
import dayjs from "dayjs";
import AddIcon from "@mui/icons-material/Add";
import { Toast } from "primereact/toast";
import BlockBackButton from "../BlockBackButton";
import { offlineStorage } from "../../Utils/OfflineStorage";
import ModalComponent from "../reusable Component/modalComponent";
import { useNavigate } from "react-router-dom";
import DeleteIcon from "@mui/icons-material/Delete";
import imageCompression from "browser-image-compression";
import { set } from "date-fns";
import FarmVisitFormComponent from "./FarmVisitFormComponent";

const buttonStyle = {
  border: "1px solid #fff",
  borderRadius: "4px",
  margin: "5px",
  width: "40px",
  height: "40px",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: "#097969",
  color: "#fff",
  transition: "background-color 0.3s, transform 0.2s",
  boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",
};

const hoverEffects = (e, isHovering) => {
  e.currentTarget.style.backgroundColor = isHovering ? "#0B9B73" : "#097969";
  e.currentTarget.style.transform = isHovering ? "scale(1.05)" : "scale(1)";
};

export const BdmToDoPage = () => {
  const [initialTaskSections, setInitialTaskSections] = useState([]);
  const [dailyTaskSections, setDailyTaskSections] = useState([]);
  const [openTaskListModal, setOpenTaskListModal] = useState(false);
  const [modalJustClosed, setModalJustClosed] = useState(false);
  const [expandedRow, setExpandedRow] = useState(null);
  const [expandedRemarks, setExpandedRemarks] = useState({});
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [severity, setSeverity] = useState("");
  const [message, setMessage] = useState("");
  const [runEffect, setRunEffect] = useState(false);

  const storedRole = localStorage.getItem("empRole");

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const storedId = localStorage.getItem("username");
  const storedAttId =
    JSON.parse(localStorage.getItem("userData") || "{}")?.todayAttendance
      ?.attendanceId ??
    JSON.parse(localStorage.getItem("attendance") || "{}")?.attendanceId ??
    null;

  const [travelDetailsId, setTravelDetailsId] = useState("");
  const [placeOfSubmit, setPlaceOfSubmit] = useState("");
  const [isAttendanceInDone, setIsAttendanceInDone] = useState(false);

  const [farmList, setFarmList] = useState([]);

  useEffect(() => {
    fetchDailyTasks();
  }, []);

  useEffect(() => {
    if (modalJustClosed) {
      fetchDailyTasks();
      setModalJustClosed(false);
    }
  }, [modalJustClosed]);

  const fetchDailyTasks = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${BASE_URL}/bdm-daily-tasks/${storedId}`);
      if (!response.ok) throw new Error("Network response was not ok");

      const data = await response.json();

      // Preserve previous travel_details1 values
      const previousTravelDetails = dailyTaskSections.reduce((acc, section) => {
        section.tasks.forEach((task) => {
          acc[task.id] = task.travel_details1 || {};
        });
        return acc;
      }, {});

      const newTaskSections = [
        {
          title: "HO Task",
          tasks:
            data.tasks.HO_task?.map((task) => ({
              id: task.id,
              CustomerName: task.lead?.CustomerName,
              MobileNo: task.lead?.MobileNo,
              category: task.lead?.category,
              sub_category: task.lead?.sub_category,
              location: task.lead?.location,
              agent_remark: task.lead?.agent_remark,
              bdm_remark: task.lead?.bdm_remark || task.remarks,
              regionalOffice: task.regionalOffice,
              branchOffice: task.branchOffice,
              leadId: task.lead?.Id,
              follow_up_date: task.action_date,
              disabled: false,
              postponedDate: task.new_follow_up_date,
              confirmed: task.action_type === "confirm",
              isSelfTask: false,
              specific_action: task.specific_action,
              remark: task.lead?.agent_remark,
              completion_status: task.completion_status,
              travel_details: task.travel_details,
              travel_details1: previousTravelDetails[task.id] || {},
              travel_form_details: task.travel_form_details,
            })) ?? [],
        },
        {
          title: "Self Task",
          tasks:
            data.tasks.self_task?.map((task) => ({
              id: task.id,
              CustomerName: task.lead?.CustomerName,
              MobileNo: task.lead?.MobileNo,
              location: task.lead?.location,
              category: task.lead?.category,
              sub_category: task.lead?.sub_category,
              agent_remark: task.lead?.agent_remark,
              regionalOffice: task.regionalOffice,
              branchOffice: task.branchOffice,
              leadId: task.lead?.Id,
              bdm_remark: task.lead?.bdm_remark || task.remarks,
              follow_up_date: task.action_date,
              disabled: false,
              postponedDate: task.new_follow_up_date,
              confirmed: task.action_type === "confirm",
              isSelfTask: true,
              specific_action: task.specific_action,
              completion_status: task.completion_status,
              remark: task.lead?.agent_remark,
              travel_details: task.travel_details,
              travel_details1: previousTravelDetails[task.id] || {},
              travel_form_details: task.travel_form_details,
            })) ?? [],
        },
        {
          title: "Other Tasks",
          tasks:
            data.tasks.other_task?.other?.map((task) => ({
              id: task.id,
              task_name: task.task_name,
              remark: task.remarks,
              CustomerName: task.lead?.CustomerName,
              MobileNo: task.lead?.MobileNo,
              category: task.lead?.category,
              sub_category: task.lead?.sub_category,
              regionalOffice: task.regionalOffice,
              branchOffice: task.branchOffice,
              location: task.lead?.location,
              agent_remark: task.lead?.agent_remark,
              bdm_remark: task.lead?.bdm_remark || task.remarks,
              leadId: task.lead?.Id,
              follow_up_date: task.action_date,
              disabled: false,
              postponedDate: task.new_follow_up_date,
              confirmed: task.action_type === "confirm",
              specific_action: task.specific_action,
              completion_status: task.completion_status,
              remarks: task.lead?.agent_remark,
              travel_details: task.travel_details,
              travel_details1: previousTravelDetails[task.id] || {},
              travel_form_details: task.travel_form_details,
            })) ?? [],
        },
        {
          title: "New Tasks",
          tasks: [
            ...(data.tasks.other_task?.site_visit?.map((task) => ({
              id: task.id,
              task_name: task.task_name,
              remark: task.remarks,
              CustomerName: task.lead?.CustomerName,
              MobileNo: task.lead?.MobileNo,
              category: task.lead?.category,
              sub_category: task.lead?.sub_category,
              location: task.lead?.location,
              regionalOffice: task.regionalOffice,
              branchOffice: task.branchOffice,
              agent_remark: task.lead?.agent_remark,
              bdm_remark: task.lead?.bdm_remark || task.remarks,
              leadId: task.lead?.Id,
              follow_up_date: task.action_date,
              disabled: false,
              postponedDate: task.new_follow_up_date,
              confirmed: task.action_type === "confirm",
              specific_action: task.specific_action,
              remarks: task.lead?.agent_remark,
              completion_status: task.completion_status,
              travel_details: task.travel_details,
              travel_details1: previousTravelDetails[task.id] || {},
              travel_form_details: task.travel_form_details,
            })) ?? []),
            ...(data.tasks.other_task?.meeting?.map((task) => ({
              id: task.id,
              task_name: task.task_name,
              remark: task.remarks,
              CustomerName: task.lead?.CustomerName,
              MobileNo: task.lead?.MobileNo,
              category: task.lead?.category,
              sub_category: task.lead?.sub_category,
              location: task.lead?.location,
              regionalOffice: task.regionalOffice,
              branchOffice: task.branchOffice,
              agent_remark: task.lead?.agent_remark,
              bdm_remark: task.lead?.bdm_remark || task.remarks,
              leadId: task.lead?.Id,
              follow_up_date: task.action_date,
              disabled: false,
              postponedDate: task.new_follow_up_date,
              confirmed: task.action_type === "confirm",
              specific_action: task.specific_action,
              remarks: task.lead?.agent_remark,
              completion_status: task.completion_status,
              travel_details: task.travel_details,
              travel_details1: previousTravelDetails[task.id] || {},
              travel_form_details: task.travel_form_details,
            })) ?? []),
          ],
        },
      ];

      setDailyTaskSections(newTaskSections);

      setLoading(false);
      if (data.attendance && data.attendance.attendanceId) {
        setIsAttendanceInDone(true);
      }

      localStorage.setItem("attendance", JSON.stringify(data.attendance));

      const allSectionsEmpty = newTaskSections.every(
        (section) => section.tasks.length === 0
      );
      setOpenTaskListModal(allSectionsEmpty);
    } catch (error) {
      console.error("Error fetching daily tasks:", error);
      setLoading(false);
    }
  };

  const fetchFarmData = async () => {
    try {
      const response = await axios.get(`${GET_FARM_DATA}/${storedId}/farms`);
      setFarmList(response.data.data || []);
    } catch (error) {
      console.error("Error fetching daily tasks:", error);
      setLoading(false);
    }
  };

  const allRequiredTasksHandled = () => {
    return dailyTaskSections.every((section) =>
      section.tasks.every((task) => task.confirmed || task.postponedDate)
    );
  };

  const handleCloseModal = () => {
    setOpenTaskListModal(false);
    setModalJustClosed(true);
  };

  const toggleRow = (taskId) => {
    setExpandedRow(expandedRow === taskId ? null : taskId);
  };

  const toggleRemarks = (taskId) => {
    setExpandedRemarks((prev) => ({ ...prev, [taskId]: !prev[taskId] }));
  };

  // State for confirmation dialog
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [selectedTask, setSelectedTask] = useState(null);
  const [checkInLoading, setCheckInLoading] = useState(false);

  // Handle Check In button click
  const handleCheckIn = (task) => {
    setSelectedTask(task);
    setOpenConfirmDialog(true); // Show the confirmation dialog
  };

  // Handle the confirmation action
  // const confirmCheckIn = async () => {

  //   if (selectedTask) {
  //     setCheckInLoading(true);
  //     navigator.geolocation.getCurrentPosition(
  //       async (position) => {
  //         const { latitude, longitude } = position.coords;

  //         // Create the payload with the task details and location data
  //         const payload = {
  //           bdmId: storedId,
  //           leadDetailId: selectedTask?.leadId || null,
  //           attendanceId: storedAttId,
  //           action: selectedTask?.specific_action,
  //           bdmLeadActionId: selectedTask?.id,
  //           latitude: latitude,
  //           longitude: longitude,
  //         };
  //         console.log(payload);

  //         setOpenConfirmDialog(false); // Close the confirmation dialog

  //         try {
  //           const response = await axios.post(`${CHECK_IN}`, payload);
  //           const { data } = response.data;

  //           // Reset selected task after confirming
  //           setSelectedTask(null);
  //           fetchDailyTasks();
  //         } catch (error) {
  //           console.error("Error submitting actions:", error);
  //           // Handle error (show an alert, or set error state)
  //           // Reset selected task after confirming
  //           setSelectedTask(null);
  //           setOpenConfirmDialog(false); // Close the confirmation dialog
  //         } finally {
  //           setCheckInLoading(false); // Reset loading state
  //         }
  //       },
  //       (error) => {
  //         // Handle error when geolocation fails
  //         console.error("Error fetching location:", error);
  //         // Set a fallback location or show an error message
  //       },
  //       {
  //         enableHighAccuracy: true,
  //         timeout: 5000,
  //         maximumAge: 0,
  //       }
  //     );
  //   }
  // };

  const confirmCheckIn = async () => {
    if (!selectedTask) return;

    setCheckInLoading(true);

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const { latitude, longitude } = position.coords;

        const payload = {
          bdmId: storedId,
          leadDetailId: selectedTask?.leadId || null,
          attendanceId: storedAttId,
          action: selectedTask?.specific_action,
          bdmLeadActionId: selectedTask?.id,
          latitude,
          longitude,
        };

        setOpenConfirmDialog(false);

        // Save data to IndexedDB immediately for safety
        const savedData = await offlineStorage.saveCheckInData(
          "check_in",
          payload
        );

        const checkNetworkSpeed = async () => {
          if (!navigator.onLine)
            return { isGoodSpeed: false, networkDelay: Infinity };
          try {
            const startTime = Date.now();
            const response = await fetch("/api/ping", { timeout: 2000 });
            const endTime = Date.now();
            const networkDelay = endTime - startTime;
            return {
              isGoodSpeed: networkDelay < 2000 && response.ok,
              networkDelay,
            };
          } catch {
            return { isGoodSpeed: false, networkDelay: Infinity };
          }
        };

        const attemptSync = async () => {
          if (!navigator.onLine) {
            setTimeout(attemptSync, 10000); // Retry every 10 seconds when offline
            return;
          }

          try {
            const response = await axios.post(`${CHECK_IN}`, payload);
            if (response.data?.message === "Check-in recorded successfully") {
              await offlineStorage.removePendingSubmission(
                savedData.id,
                "check_in"
              );
              setMessage("Check-in successfully submitted.");
              setSeverity("success");
            }
          } catch (error) {
            if (error.response?.data?.message === "Check-in already recorded") {
              await offlineStorage.removePendingSubmission(
                savedData.id,
                "check_in"
              );
              setMessage("Check-in successfully submitted.");
              setSeverity("success");
            } else {
              console.error("Background sync failed, retrying...", error);
              setTimeout(attemptSync, 10000); // Retry every 10 seconds
            }
          } finally {
            setOpenSnackbar(true);
            setCheckInLoading(false);
            setMessage(
              "Not able to Check-in as the network speed is too low.Please try after some time"
            );
            setSeverity("error");
          }
        };

        const { isGoodSpeed, networkDelay } = await checkNetworkSpeed();

        if (isGoodSpeed) {
          try {
            const response = await axios.post(`${CHECK_IN}`, payload);
            const { data } = response.data;

            setSelectedTask(null);
            setCheckInLoading(false);
            fetchDailyTasks();
            await offlineStorage.removePendingSubmission(
              savedData.id,
              "check_in"
            );

            setMessage("Check-in submitted successfully.");
            setSeverity("success");
          } catch (error) {
            console.error("Network failed, saving data offline.", error);
            attemptSync(); // Start retry logic immediately
          }
        } else {
          setMessage(
            "Network too slow. Check-in saved offline and will sync automatically."
          );
          setSeverity("warning");
          attemptSync(); // Start retry logic immediately
        }
      },
      (error) => {
        console.error("Error fetching location:", error);
        setSeverity("error");
        setMessage(
          "Unable to capture location. Internet may be too weak or GPS is disabled."
        );
        setOpenSnackbar(true);
        setCheckInLoading(false);
      },
      {
        enableHighAccuracy: true,
        timeout: 20000,
        maximumAge: 0,
      }
    );
  };

  // const confirmCheckIn = async () => {
  //   if (!selectedTask) return;

  //   setCheckInLoading(true);

  //   navigator.geolocation.getCurrentPosition(
  //       async (position) => {
  //           const { latitude, longitude } = position.coords;

  //           const payload = {
  //               bdmId: storedId,
  //               leadDetailId: selectedTask?.leadId || null,
  //               attendanceId: storedAttId,
  //               action: selectedTask?.specific_action,
  //               bdmLeadActionId: selectedTask?.id,
  //               latitude,
  //               longitude,
  //           };

  //           setOpenConfirmDialog(false);

  //           // Save data to IndexedDB immediately
  //           const savedData = await offlineStorage.saveCheckInData("check_in", payload);

  //           const attemptSync = async () => {
  //               if (!navigator.onLine) {
  //                   setTimeout(attemptSync, 10000); // Retry every 10 seconds when offline
  //                   return;
  //               }

  //               try {
  //                   const response = await axios.post(`${CHECK_IN}`, payload);
  //                   if (response.data?.message === "Check-in recorded successfully") {
  //                       await offlineStorage.removePendingSubmission(savedData.id, "check_in");
  //                       setMessage("Check-in successfully submitted.");
  //                       setSeverity("success");
  //                   }
  //               } catch (error) {
  //                   if (error.response?.data?.message === "Check-in already recorded") {
  //                       await offlineStorage.removePendingSubmission(savedData.id, "check_in");
  //                       setMessage("Check-in successfully submitted.");
  //                       setSeverity("success");
  //                   } else {
  //                       console.error("Background sync failed, retrying...", error);
  //                       setTimeout(attemptSync, 10000); // Retry every 10 seconds
  //                   }
  //               } finally {
  //                   setOpenSnackbar(true);
  //                   setCheckInLoading(false);
  //               }
  //           };

  //           setMessage("Check-in saved offline and will sync automatically.");
  //           setSeverity("warning");
  //           attemptSync(); // Start retry logic immediately
  //       },
  //       (error) => {
  //           console.error("Error fetching location:", error);
  //           setCheckInLoading(false);
  //       },
  //       {
  //           enableHighAccuracy: true,
  //           timeout: 5000,
  //           maximumAge: 0,
  //       }
  //   );
  // };

  const handleCloseDialog = () => {
    setOpenConfirmDialog(false); // Close the dialog without confirming
  };

  const [openCheckoutDialog, setOpenCheckoutDialog] = useState(false);
  const [checkoutTask, setCheckoutTask] = useState([]);
  const [isCheckoutDone, setIsCheckoutDone] = useState(false);

  const handleCheckout = (task) => {
    setCheckoutTask(task);
    setOpenCheckoutDialog(true);
  };

  const confirmCheckout = () => {
    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const { latitude, longitude } = position.coords;

        // Create the payload with the task details and location data
        const payload = {
          travelDetailId: checkoutTask?.travel_details?.travel_detailsId,
          bdmLeadActionId: checkoutTask?.id,
          latitude: latitude,
          longitude: longitude,
        };
        setIsCheckoutDone(true);
        try {
          const response = await axios.post(`${CHECK_OUT}`, payload);

          console.log(response.data);
          setOpenCheckoutDialog(false);
          fetchDailyTasks();
        } catch (error) {
          console.error("Error submitting actions:", error);
          setOpenCheckoutDialog(false);
        } finally {
          setIsCheckoutDone(false);
        }
      },
      (error) => {
        // Handle error when geolocation fails
        console.error("Error fetching location:", error);
        setSeverity("error");
        setMessage(
          "Unable to capture location. Internet may be too weak or GPS is disabled."
        );
        setOpenSnackbar(true);
        // Set a fallback location or show an error message
      },
      {
        enableHighAccuracy: true,
        timeout: 20000,
        maximumAge: 0,
      }
    );
  };

  const handleCloseCheckoutDialog = () => {
    setOpenCheckoutDialog(false);
    setCheckoutTask([]);
  };

  const [openTaskDialog, setOpenTaskDialog] = useState(false);
  const [typeOfTask, setTypeOfTask] = useState("");
  const [leadId, setLeadId] = useState("");
  const [bdmLeadActionId, setBdmLeadActionId] = useState("");

  const onRowClick = (task) => {
    console.log(task);

    setOpenTaskDialog(true);
    setTypeOfTask(task.specific_action);
    setBdmLeadActionId(task.id);
    setLeadId(task.leadId);
    setTravelDetailsId(task.travel_details?.travel_detailsId);
    setPlaceOfSubmit("Todo");
  };

  const handleCloseTaskDialog = () => {
    setOpenTaskDialog(false);
  };

  const [showMeetingForm, setShowMeetingForm] = useState(false);
  const [siteVisitForm, setSiteVisitForm] = useState(false);

  const [selectedOtherTask, setSelectedOtherTask] = useState("");
  const [otherTasks, setOtherTasks] = useState([]);
  const [remark, setRemark] = useState("");
  const [error, setError] = useState("");
  const [remarkError, setRemarkError] = useState("");
  const [addTaskDialog, setAddTaskDialog] = useState(false);

  const [addTaskDialog1, setAddTaskDialog1] = useState(false);

  // Handle adding "Other Tasks"
  const handleAddTask = () => {
    if (!remark || remark.length < 5) {
      setRemarkError("Remark must be at least 5 characters.");
      return;
    }

    if (selectedOtherTask && remark) {
      const newTask = {
        task_name: selectedOtherTask,
        remarks: remark,
      };

      setOtherTasks((prevTasks) => [newTask, ...prevTasks]); // Add new task to the list
      setSelectedOtherTask(""); // Clear the selected task
      setRemark(""); // Clear the remark
      setError(""); // Clear any errors
      setRemarkError("");
    } else {
      setError("Please select a task and enter a remark."); // Show error if fields are empty
    }
  };

  const handleCloseAddTaskDialog = () => {
    setAddTaskDialog(false);
    setAddTaskDialog1(false);
    setSelectedOtherTask(""); // Clear the selected task
    setRemark(""); // Clear the remark
    setError(""); // Clear any errors
    setOtherTasks([]);
    setMobileNumber("");
    setCustomerData([]);
    setRemarkError("");
    setMobileNumberError("");
    setSelectedTaskLocation("");
    setBranchList([]);
    setRoList([]);
    setBranch("");
    setRegionalOffice("");
  };

  const [mobileNumber, setMobileNumber] = useState("");
  const [mobileNumberError, setMobileNumberError] = useState("");
  const [mobileLoading, setMobileLoading] = useState("");
  const [customerData, setCustomerData] = useState([]);

  const [sunmitLoading, setSubmitLoading] = useState(false);

  const handleSubmitNewTask = async () => {
    try {
      let updatedTasks = [...otherTasks];

      // Case 1: No tasks added via +, but current selection exists
      if (updatedTasks.length === 0) {
        if (!selectedOtherTask || !remark || remark.trim().length < 5) {
          setRemarkError("Remark must be at least 5 characters.");
          return;
        }

        updatedTasks.push({ task_name: selectedOtherTask, remarks: remark, });
      }

      // If the user has selected a task and entered a remark but hasn't added it via '+', add it to the list
      // if (selectedOtherTask && remark) {
      //   updatedTasks = [
      //     ...updatedTasks,
      //     { task_name: selectedOtherTask, remarks: remark },
      //   ];
      // }
      setSubmitLoading(true);

      const payload = {
        bdmId: storedId,
        other_task: updatedTasks,
      };

      const response = await axios.post(`${SUBMIT_ADD_OTHER_TASKS}`, payload);
      console.log(response.data);
      setOpenSnackbar(true);
      setMessage(response.data.message);
      setSeverity("success");
      handleCloseAddTaskDialog();
      fetchDailyTasks();
      setSubmitLoading(false);
    } catch (error) {
      console.log("Error submitting tasks.", error);
      setOpenSnackbar(true);
      setMessage(error.response?.data?.message || "An error occurred.");
      setSeverity("error");
      setSubmitLoading(false);
    }
  };

  const [confirmDisable, setConfirmDisable] = useState(false);

  const getDataByMobileNumber = (MobileNo) => {
    if (MobileNo.length === 10) {
      setMobileLoading(true);
      setConfirmDisable(true); // Disable the button initially

      axios
        .get(`${GET_DETAILS_BY_MOBILE_NUMBER}/${MobileNo}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        })
        .then((response) => {
          const { lead, message } = response.data;

          if (
            !lead ||
            Object.keys(lead).length === 0 ||
            message === "Lead not found for the given mobile number"
          ) {
            setSeverity("success");
            setMessage("Lead not found for the given mobile number");
            setOpenSnackbar(true);
            setConfirmDisable(true); // Keep it disabled
            setCustomerData([]);
            return;
          }

          // Lead found, enable the button
          setCustomerData(lead);
          // setSeverity("success");
          // setMessage(message);
          // setOpenSnackbar(true);
          setConfirmDisable(false);
        })
        .catch((error) => {
          setMobileNumberError("Failed to fetch data. Please try again.");
          setConfirmDisable(true); // Ensure it's disabled on error
          setCustomerData([]);
        })
        .finally(() => {
          setMobileLoading(false);
        });
    }
  };

  const handleConfirmAction = () => {
    console.log(selectedOtherTask);
    console.log("confimation clicked");
    
    if (
      ["Site Visit", "Meeting_Office", "Meeting_Field",].includes(
        selectedOtherTask
      )
    ) {
      if (!mobileNumber || mobileNumber.length !== 10) {
        setMobileNumberError("Valid mobile number is required.");

        return;
      }

      const task = {
        id: customerData.id,
        task_name: selectedOtherTask,
        action_type: "confirm",
        remark: "",
      };

      if (selectedOtherTask === "Meeting_Office") {
        task.selectedTaskLocation = selectedTaskLocation;
        task.branchOffice = selectedTaskLocation === "bo" ? branch : null;
        task.regionalOffice =
          selectedTaskLocation === "ro" ? regionalOffice : null;
      }

      const allTasks = [...otherTasks, task];

      submitTasksToAPI(allTasks);
    } else if (
      [
        "HO Visit",
        "RO Visit",
        "Expo Event",
        "BO Visit",
        "Travel",
        "Group Meeting",
        "Farm Visit",
        "Head Office Visit",
      ].includes(selectedOtherTask)
    ) {
      if (!remark || remark.trim().length < 5) {
        setRemarkError("Remark must be at least 5 characters.");

        return;
      }
      // Combine all tasks if any "Other Task" was added before Site Visit / Meeting
      const allTasks = [
        ...otherTasks,
        {
          id: customerData.id,
          task_name: selectedOtherTask,
          action_type: "confirm",
          remarks: remark,
        },
      ];
      submitTasksToAPI(allTasks);
    } else {
      handleSubmitNewTask();
    }
  };

  const submitTasksToAPI = async (tasks) => {
    setSubmitLoading(true);
    try {
      const payload = {
        bdmId: storedId,
        other_task: tasks,
      };

      const response = await axios.post(`${SUBMIT_ADD_OTHER_TASKS}`, payload);
      console.log(response.data);
      setOpenSnackbar(true);
      setMessage(response.data.message);
      setSeverity("success");
      handleCloseAddTaskDialog();
      fetchDailyTasks();
      setSubmitLoading(false);
    } catch (error) {
      console.log("Error submitting tasks.", error);
      setSubmitLoading(false);
    }
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbar(false);
  };

  const [isDisabled, setIsDisabled] = useState(false);

  const isPreviousCheckoutMissing = (taskId) => {
    // Loop through the task categories in dailyTaskSections
    for (let section of dailyTaskSections) {
      const taskArray = section.tasks;

      // Check if the task is in this category's array
      const taskIndex = taskArray.findIndex((task) => task.id === taskId);

      // If task is not found in the current section, continue to the next section
      if (taskIndex === -1) {
        continue;
      }

      // Loop through all tasks in all sections to check if any previous task hasn't checked out yet
      for (let s of dailyTaskSections) {
        for (let task of s.tasks) {
          // Skip current task
          if (task.id === taskId) continue;

          // Check if the task has checked in but not checked out
          const hasCheckedIn = task.travel_details?.checkin_time;

          const hasCheckedOut =
            task.travel_details?.checkout_time ||
            task.travel_details1?.checkout_time ||
            !task.travel_details1;

          // Check if the task has checked in but not checked out
          if (hasCheckedIn && !hasCheckedOut) {
            console.log(
              "A previous task hasn't checked out. Returning true (disable check-in)."
            );
            return true; // Disable check-in if any previous task hasn't checked out
          }
        }
      }
      // If no previous task was found with check-in but no checkout, enable check-in
      return false;
    }

    console.log("No matching taskId found. Returning false.");
    return false; // If no matching taskId is found, return false
  };

  const toast = useRef(null);

  useEffect(() => {
    const handleSync = (event) => {
      // If needsRefresh is true, refresh the data
      if (event.detail.needsRefresh) {
        fetchDailyTasks(); // Refresh data
      }

      // Show success message
      if (event.detail.type === "meeting") {
        setSeverity("success");
        setMessage("Meeting synced successfully!");
        setOpenSnackbar(true);
      }
      if (event.detail.type === "site_visit") {
        setSeverity("success");
        setMessage("Site Visit synced successfully!");
        setOpenSnackbar(true);
      }
      if (event.detail.type === "check_in") {
        setSeverity("success");
        setMessage("Check in synced successfully!");
        setOpenSnackbar(true);
      }
    };

    window.addEventListener("submission-synced", handleSync);
    return () => window.removeEventListener("submission-synced", handleSync);
  }, []);

  const lastOfflineDataRef = useRef(null); // Store last known offline data

  const fetchOfflineData = async () => {
    try {
      const offlineData = await offlineStorage.getPendingSubmissions();

      console.log(offlineData, "----");

      // Check if offlineData is different from last fetched data
      if (
        !offlineData.length ||
        JSON.stringify(offlineData) ===
          JSON.stringify(lastOfflineDataRef.current)
      ) {
        console.log("reject");
        return; // Avoid unnecessary updates
      }

      lastOfflineDataRef.current = offlineData; // Store last known offline data

      const updatedTaskSections = mergeTravelDetails(
        dailyTaskSections,
        offlineData
      );

      console.log("updatedTaskSections", updatedTaskSections);

      setDailyTaskSections(updatedTaskSections);
    } catch (error) {
      console.error("Error fetching offline data:", error);
    }
  };

  // Merging logic
  const mergeTravelDetails = (newTaskSections, travelDetailsData) => {
    return newTaskSections.map((section) => {
      const updatedTasks = section.tasks.map((task) => {
        const matchedTravelDetails = travelDetailsData.find(
          (data) => Number(data.bdmLeadActionId) === task.id
        );

        // Always return the task, even if no match is found
        if (matchedTravelDetails) {
          return {
            ...task,
            travel_details1: matchedTravelDetails.travel_details,
          };
        }

        return { ...task }; // Return the task unchanged
      });

      return { ...section, tasks: updatedTasks };
    });
  };

  // Call fetchOfflineData in useEffect
  useEffect(() => {
    fetchOfflineData();

    const interval = setInterval(() => {
      if (navigator.onLine) {
        fetchOfflineData();
      }
    }, 5000); // Increased interval to 5 seconds to reduce flickering

    return () => clearInterval(interval);
  }, [dailyTaskSections]);

  const [open, setOpen] = useState(false);
  const [editMobNo, setEditMobNo] = useState("");

  const [leadNumber, setLeadNumber] = useState("");

  const [openVisitFormsDialog, setOpenVisitFormsDialog] = useState("");
  const [formErrors, setFormErrors] = useState({});

  const [branch, setBranch] = useState("");
  const [selection, setSelection] = useState("");
  const [customers, setCustomers] = useState([]);
  const [mobileInput, setMobileInput] = useState("");
  const [searchedCustomer, setSearchedCustomer] = useState(null);
  const [concernPerson, setConcernPerson] = useState("");
  const [adminTask, setAdminTask] = useState("");
  const [othersRemark, setOthersRemark] = useState("");
  const [regionalOffice, setRegionalOffice] = useState("");
  const [hoSelection, setHoSelection] = useState("");
  const [travelSelection, setTravelSelection] = useState("");
  const [fromLocation, setFromLocation] = useState("");
  const [toLocation, setToLocation] = useState("");
  const [nearestBranch, setNearestBranch] = useState("");
  const [travelRemark, setTravelRemark] = useState("");
  const [visitPictureMandatory, setVisitPictureMandatory] = useState(null);
  const [visitPictureOptional, setVisitPictureOptional] = useState(null);
  const [branchList, setBranchList] = useState([]);
  const [roList, setRoList] = useState([]);
  const [branchLoading, setBranchLoading] = useState(false);
  const [selectedtaskLocation, setSelectedtaskLocation] = useState("");
  const [selectedTaskLocation, setSelectedTaskLocation] = useState("");

  const [notALead, setNotALead] = useState(false);

  const getBOandROListByBdm = async () => {
    try {
      setBranchLoading(true);
      const response = await axios.get(
        `${BRANCH_AND_RO_LIST_BY_BDM}/${localStorage.getItem("username")}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );
      const { regions } = response.data;

      // Flatten branches from all regions
      const branches = regions.flatMap((region) =>
        region.branches.map((b) => ({
          label: b.Branch,
          branchCode: b.BranchCode, // keep if needed for future use
        }))
      );

      // Flatten and remove duplicate RO names
      const roSet = new Set();
      const roNames = [];

      regions.forEach((region) => {
        region.branches.forEach((b) => {
          if (b.RO && !roSet.has(b.RO)) {
            roSet.add(b.RO);
            roNames.push({ label: b.RO, roCode: b.RO });
          }
        });
      });

      setBranchList(branches);
      setRoList(roNames);

      setBranchLoading(false);
    } catch (error) {
      console.error("Error fetching customer:", error);
      setBranchLoading(false);
    }
  };

  const fetchCustomerByMobileNumber = async (MobileNo) => {
    if (MobileNo.length === 10) {
      try {
        const response = await axios.get(
          `${GET_DETAILS_BY_MOBILE_NUMBER}/${MobileNo}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            },
          }
        );
        const { lead, message } = response.data;
        if (message === "Lead not found for the given mobile number") {
          return null;
        } else {
          return lead; // assuming 'lead' contains customer data
        }
      } catch (error) {
        console.error("Error fetching customer:", error);
        return null;
      }
    } else {
      return null;
    }
  };

  const [leadConfirmDialog, setLeadConfirmDialog] = useState(false);
  const [pincode, setPincode] = useState("");
  const [locationList, setLocationList] = useState([]);
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [pincodeLoading, setPincodeLoading] = useState(false);
  const [afterLeadCreatedCallback, setAfterLeadCreatedCallback] =
    useState(null);
  const [dialogType, setDialogType] = useState("");

  const fetchPincodeData = (pincode) => {
    setPincodeLoading(true);
    axios
      .get(`${STATE_API}/${pincode}`)
      .then((response) => {
        if (response.data == null) {
          setSeverity("error");
          setMessage("No Data Found for this Pincode");
          setOpenSnackbar(true);
          setLocationList([]);
          return;
        }

        //Map region so can be used for region feild
        const namesArray = response.data.places.map((item) => ({
          names: item.placeName,
        }));

        setLocationList(namesArray);
      })
      .catch((error) => {
        console.error("Error fetching pincode data:", error);
        setMessage(error.response?.data?.error || "Failed to fetch data");
        setSeverity("error");
        setOpenSnackbar(true);
        //   setStateError("Failed to fetch state. Please try again.");
      })
      .finally(() => {
        setPincodeLoading(false); // Stop loading
      });
  };

  const [hoVisitPictureMandatory, setHoVisitPictureMandatory] = useState(null);
  const [hoVisitPictureOptional, setHoVisitPictureOptional] = useState(null);
  const [loadingMandatory, setLoadingMandatory] = useState(false);
  const [loadingOptional, setLoadingOptional] = useState(false);
  const [isHoFormSubmitting, setIsHoFormSubmitting] = useState(false);
  const [isRoBoFormSubmitting, setIsRoBoFormSubmitting] = useState(false);

  const handleImageUpload = async (
    e,
    setImage,
    setPreview,
    isRequired = false,
    setLoading
  ) => {
    const file = e.target.files[0];
    if (!file) return;

    setLoading(true);
    try {
      const compressed = await imageCompression(file, {
        maxSizeMB: 2,
        maxWidthOrHeight: 1024,
        useWebWorker: true,
      });

      // Get original extension
      const extension = file.name.split(".").pop();

      // Generate unique filename with timestamp
      const uniqueName = `img_${Date.now()}.${extension}`;

      // Create final File object with unique name
      const finalFile = new File([compressed], uniqueName, {
        type: compressed.type,
        lastModified: Date.now(),
      });

      console.log("Compressed file size:", finalFile);

      setImage(finalFile);
      setPreview(URL.createObjectURL(finalFile));

      if (isRequired) {
        setFormErrors((prev) => ({ ...prev, mandatoryVisitImage: "" }));
      }
    } catch (error) {
      console.error("Compression failed:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmitHoTask = async () => {
    const newErrors = {};

    if (!hoSelection) {
      newErrors.hoSelection = "Feild is mandatory.";
    }

    if (!othersRemark.trim()) {
      newErrors.remarks = "Remarks is mandatory.";
    }

    if (!hoVisitPictureMandatory) {
      newErrors.mandatoryVisitImage =
        "Please upload the mandatory visit picture.";
    }

    // If any errors found, block submission and set errors
    if (Object.keys(newErrors).length > 0) {
      setFormErrors(newErrors);
      return;
    }

    const formData = new FormData();
    formData.append("BDMId", localStorage.getItem("username"));
    formData.append("bdmLeadActionId", bdmLeadActionId);
    formData.append("taskType", "HO Visit");
    formData.append("hoSelection", hoSelection || "");
    formData.append("remarks", othersRemark || "");
    formData.append(
      "mandatoryVisitImage",
      hoVisitPictureMandatory,
      hoVisitPictureMandatory.name
    );
    if (hoVisitPictureOptional) {
      formData.append("optionalVisitImage", hoVisitPictureOptional);
    }

    // for (let [key, value] of formData.entries()) {
    //   console.log(`${key}:`, value);
    // }
    setIsHoFormSubmitting(true);
    try {
      const response = await axios.post(`${VISIT_FORM_SUBMIT}`, formData);
      console.log(response.data);
      setOpenSnackbar(true);
      setMessage(response.data.message);
      setSeverity("success");
      setOpenVisitFormsDialog(false);
      handleResetHoForm();
      fetchDailyTasks();
    } catch (error) {
      console.log("Error submitting tasks.", error);
      const backendErrors = error?.response?.data?.errors || [];
      const errorMap = {};
      backendErrors.forEach((err) => {
        if (err.field && err.message) {
          errorMap[err.field] = err.message;
        }
      });
      setFormErrors(errorMap);
    } finally {
      setIsHoFormSubmitting(false);
    }
  };

  const handleResetHoForm = () => {
    setTypeOfTask("");
    setHoSelection("");
    setOthersRemark("");
    setHoVisitPictureMandatory(null);
    setHoVisitPictureOptional(null);
    setBdmLeadActionId("");
    setPreviewUrl(null);
    setPreviewOptionalUrl(null);
  };

  const handleROorBOVisitSubmit = async () => {
    const errors = {};

    const isROVisit = typeOfTask === "RO Visit";
    const isBOVisit = typeOfTask === "BO Visit";
    const isAdminWork = selection === "Admin_Work";
    const isMeeting = selection === "Meeting_with_RH_BM_ZH";

    // Validation
    if (isROVisit) {
      if (!regionalOffice.trim())
        errors.regionalOfficeName = "RO Name is Mandatory.";
    }
    if (isBOVisit) {
      if (!branch.trim()) errors.branchName = "Branch Name is Mandatory.";
    }
    if (!selection.trim()) errors.purposeForVisit = "Purpose is Mandatory.";
    if (isMeeting && !concernPerson.trim())
      errors.concernPersonName = "Concern Person Name is Mandatory.";
    if (isAdminWork && !adminTask)
      errors.adminTaskSelect = "Admin Task is Mandatory.";

    if (!othersRemark.trim()) errors.remarks = "Remark is Mandatory.";
    if (!visitPictureMandatory)
      errors.mandatoryVisitImage = "Please upload the mandatory visit picture.";

    if (Object.keys(errors).length) {
      setFormErrors(errors);
      return;
    }

    // Construct FormData
    const formData = new FormData();
    formData.append("BDMId", localStorage.getItem("username") || "");
    formData.append("bdmLeadActionId", bdmLeadActionId);
    formData.append("taskType", isROVisit ? "RO Visit" : "BO Visit");
    formData.append("branchName", isROVisit ? "" : branch || "");
    formData.append("regionalOfficeName", isROVisit ? regionalOffice : "");
    formData.append("purposeForVisit", selection);

    if (isMeeting) formData.append("concernPersonName", concernPerson || "");
    if (isAdminWork) formData.append("adminTaskSelect", adminTask || "");
    formData.append("remarks", othersRemark || "");

    formData.append(
      "mandatoryVisitImage",
      visitPictureMandatory,
      visitPictureMandatory.name
    );
    if (visitPictureOptional) {
      formData.append("optionalVisitImage", visitPictureOptional);
    }

    // Debug log
    for (let [key, value] of formData.entries()) {
      console.log(`${key}:`, value);
    }

    setIsRoBoFormSubmitting(true);

    // API call
    try {
      const response = await axios.post(VISIT_FORM_SUBMIT, formData);
      console.log("Submit success:", response.data);
      setOpenSnackbar(true);
      setMessage(response.data.message);
      setSeverity("success");
      setOpenVisitFormsDialog(false);
      handleResetRoBoForm();
      fetchDailyTasks();
    } catch (error) {
      console.error("Error submitting task:", error);
      const backendErrors = error?.response?.data?.errors || [];
      const errorMap = {};
      backendErrors.forEach(({ field, message }) => {
        if (field && message) errorMap[field] = message;
      });
      setFormErrors(errorMap);
    } finally {
      setIsRoBoFormSubmitting(false);
    }
  };

  const handleResetRoBoForm = () => {
    setTypeOfTask("");
    setBranch("");
    setRegionalOffice("");
    setConcernPerson("");
    setSelection("");
    setOthersRemark("");
    setAdminTask("");
    setOtherTasks("");
    setVisitPictureMandatory(null);
    setVisitPictureOptional(null);
    setBdmLeadActionId("");
    setPreviewUrl(null);
    setPreviewOptionalUrl(null);
  };

  const [travelPictureMandatory, setTravelPictureMandatory] = useState(null);
  const [travelPictureOptional, setTravelPictureOptional] = useState(null);
  const [reasonForTravel, setReasonForTravel] = useState("");
  const [isTravelSubmitting, setIsTravelSubmitting] = useState(false);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [previewOptionalUrl, setPreviewOptionalUrl] = useState(null);

  const handleTravelFormSubmit = async () => {
    const newErrors = {};

    if (!travelSelection) {
      newErrors.modeOfTravel = "Please select a mode of travel";
    }

    if (!reasonForTravel) {
      newErrors.reasonForTravel = "Please select a reason for travel";
    }

    if (!fromLocation.trim()) {
      newErrors.travelFrom = "From location is required";
    }

    if (!toLocation.trim()) {
      newErrors.travelTo = "To location is required";
    }

    if (!travelPictureMandatory) {
      newErrors.mandatoryVisitImage = "Visit Image1 is mandatory";
    }

    if (!travelRemark.trim()) {
      newErrors.remarks = "Remark is mandatory";
    }

    // If any errors found, block submission and set errors
    if (Object.keys(newErrors).length > 0) {
      setFormErrors(newErrors);
      return;
    }

    setIsTravelSubmitting(true);
    const formData = new FormData();
    formData.append("BDMId", localStorage.getItem("username"));
    formData.append("bdmLeadActionId", bdmLeadActionId);
    formData.append("taskType", "travel");
    formData.append("modeOfTravel", travelSelection || null);
    formData.append("reasonForTravel", reasonForTravel);
    formData.append("travelFrom", fromLocation || "");
    formData.append("travelTo", toLocation || "");
    formData.append("remarks", travelRemark || null);
    formData.append(
      "mandatoryVisitImage",
      travelPictureMandatory,
      travelPictureMandatory.name
    );
    if (travelPictureOptional) {
      formData.append("optionalVisitImage", travelPictureOptional);
    }

    try {
      const response = await axios.post(`${VISIT_FORM_SUBMIT}`, formData);
      console.log(response.data);
      setOpenSnackbar(true);
      setMessage(response.data.message);
      setSeverity("success");
      setOpenVisitFormsDialog(false);
      handleResetTravelForm();
      fetchDailyTasks();
    } catch (error) {
      console.log("Error submitting tasks.", error.response.data.errors);
      if (error.response.data.errors === undefined) {
        setOpenSnackbar(true);
        setMessage(error.response.data.error);
        setSeverity("error");
      } else {
        const backendErrors = error?.response?.data?.errors || [];
        const errorMap = {};
        backendErrors.forEach((err) => {
          if (err.field && err.message) {
            errorMap[err.field] = err.message;
          }
        });
        setFormErrors(errorMap);
      }
    } finally {
      setIsTravelSubmitting(false);
    }
  };

  const handleResetTravelForm = () => {
    setTravelSelection("");
    setFromLocation("");
    setToLocation("");
    setReasonForTravel("");
    setTravelRemark("");
    setTravelPictureMandatory(null);
    setTravelPictureOptional(null);
    setFormErrors({});
    setBdmLeadActionId("");
    setPreviewUrl(null);
    setPreviewOptionalUrl(null);
  };

  // State to handle dialog
  const [openImageDialog, setOpenImageDialog] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

 

  // Handle image preview
  const handleImageClick = (imgUrl) => {
    setSelectedImage(imgUrl);
    setOpenImageDialog(true);
  };

  const getLocation = () => {
    return new Promise((resolve, reject) => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            resolve({
              latitude: position.coords.latitude,
              longitude: position.coords.longitude,
            });
          },
          (error) => {
            console.error("Error getting location:", error);
            resolve({ latitude: 12.9716, longitude: 77.5946 }); // Default fallback (Bangalore)
          }
        );
      } else {
        console.error("Geolocation is not supported by this browser.");
        resolve({ latitude: 12.9716, longitude: 77.5946 }); // Default fallback
      }
    });
  };

  const handleAttendanceIn = async () => {
    setLoading(true); // Set loading state
    try {
      const { latitude, longitude } = await getLocation(); // Fetch user's location

      // Prepare Payload
      const payload = {
        bdmId: storedId,
        HO_task: [],
        self_task: [],
        other_task: [],
        attendanceType: "IN",
        latitude, // Dynamically obtained
        longitude, // Dynamically obtained
      };

      const response = await axios.post(`${SUBMIT_TO_DO_TASKS}`, payload);
      const { data } = response.data;
      console.log("Success:", data);
      setSeverity('success');
      setMessage("Attendance In submitted successfully!");
      setOpenSnackbar(true);
      fetchDailyTasks();
    } catch (error) {
      console.error("Error submitting actions:", error);
      setError(error.message); // Display error message
    } finally {
      setLoading(false); // Reset loading state
    }
  };

  const handleCloseFormDialog = () => {
    setOpenTaskDialog(false);
  }

  return (
    <>
      {loading && <Loader open={loading} />}
      <Toast ref={toast} />
      <BlockBackButton></BlockBackButton>
      <div className="min-h-screen bg-gray-100">
        <main className="container mx-auto px-2 py-4">
          <header
            style={{ backgroundColor: theme.palette.primary.main }}
            className="text-white rounded-t-lg shadow-md mb-2"
          >
            <h1 className="text-2xl font-bold p-2">Today Tasks</h1>
          </header>

          <div style={{ marginBottom: "3rem" }}>
            {/* "Add Task" button displayed only once */}
            <Button
              variant="contained"
              sx={{
                background: "linear-gradient(135deg, #4CAF50 30%, #2E7D32 90%)", // Green gradient
                color: "white",
                fontWeight: "bold",
                textTransform: "none",
                borderRadius: "8px",
                padding: "6px 16px",
                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
                transition: "0.3s",
                "&:hover": {
                  background:
                    "linear-gradient(135deg, #2E7D32 30%, #1B5E20 90%)",
                  boxShadow: "0px 6px 12px rgba(0, 0, 0, 0.3)",
                },
                float: "right",
              }}
              startIcon={<AddIcon />} // Adds a "+" icon before the text
              onClick={() => {
                if (storedRole === "500") {
                  setAddTaskDialog1(true);
                } else {
                  setAddTaskDialog(true);
                }
              }}
            >
              Add Task
            </Button>

            {storedRole === "500" ? (
              <>
              <Button
                variant="contained"
                sx={{
                  background:
                    "linear-gradient(135deg, #4CAF50 30%, #2E7D32 90%)", // Green gradient
                  color: "white",
                  fontWeight: "bold",
                  textTransform: "none",
                  borderRadius: "8px",
                  padding: "6px 16px",
                  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
                  transition: "0.3s",
                  "&:hover": {
                    background:
                      "linear-gradient(135deg, #2E7D32 30%, #1B5E20 90%)",
                    boxShadow: "0px 6px 12px rgba(0, 0, 0, 0.3)",
                  },
                  float: "left",
                }}
                onClick={() => {
                  handleAttendanceIn();
                }}
                disabled={isAttendanceInDone}
              >
                Attendance In
              </Button>
          
            </>
            ) : (
              <Button
                variant="contained"
                sx={{
                  background:
                    "linear-gradient(135deg, #1976D2 30%, #0D47A1 90%)", // Blue gradient
                  color: "white",
                  fontWeight: "bold",
                  textTransform: "none",
                  borderRadius: "8px",
                  padding: "6px 16px",
                  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
                  transition: "0.3s",
                  "&:hover": {
                    background:
                      "linear-gradient(135deg, #0D47A1 30%, #082567 90%)",
                    boxShadow: "0px 6px 12px rgba(0, 0, 0, 0.3)",
                  },
                  float: "left",
                }}
                startIcon={<AddIcon />} // Adds a "+" icon before the text
                onClick={() => {
                  setOpen(true);
                  setLeadNumber("");
                }}
              >
                Add Lead
              </Button>
            )}
          </div>

          {dailyTaskSections.map((section, index) => {
            const hasTasks = section.tasks.length > 0;

            return (
              hasTasks && (
                <div key={index} className="mb-8">
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginBottom: "4px",
                    }}
                  >
                    <Typography
                      variant="h5"
                      className="font-bold text-black"
                      component="h2"
                    >
                      {section.title}
                    </Typography>

                    {/* <Button
                        variant="contained"
                        sx={{
                          background:
                            "linear-gradient(135deg, #4CAF50 30%, #2E7D32 90%)", // Green gradient
                          color: "white",
                          fontWeight: "bold",
                          textTransform: "none",
                          borderRadius: "8px",
                          padding: "6px 16px",
                          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
                          transition: "0.3s",
                          "&:hover": {
                            background:
                              "linear-gradient(135deg, #2E7D32 30%, #1B5E20 90%)",
                            boxShadow: "0px 6px 12px rgba(0, 0, 0, 0.3)",
                          },
                        }}
                        startIcon={<AddIcon />} // Adds a "+" icon before the text
                        onClick={() => setAddTaskDialog(true)}
                      >
                        Add Task
                      </Button>
                     */}
                  </div>

                  <Box
                    sx={{
                      overflowX: isMobile ? "auto" : "hidden", // Enable horizontal scrolling on small screens
                    }}
                  >
                    <TableContainer component={Paper} className="rounded-lg">
                      <Table
                        sx={{
                          "& .MuiTableCell-root": {
                            border: "1px solid rgba(224, 224, 224, 1)", // Gridlines
                          },
                        }}
                      >
                        {/* Table Header */}
                        <TableHead>
                          <TableRow style={{ backgroundColor: "#f0f0f0" }}>
                            <TableCell
                              sx={{
                                fontWeight: "bold",
                                padding: 0.5,
                                fontSize: "0.9rem",
                                color: "#333",
                                border: "1px solid rgba(224, 224, 224, 1)", // Header gridlines
                                width: "5%",
                              }}
                              align="center"
                            >
                              SNo.
                            </TableCell>
                            {section.title !== "Other Tasks" && (
                              <TableCell
                                sx={{
                                  fontWeight: "bold",
                                  padding: 0.5,
                                  fontSize: "0.9rem",
                                  color: "#333",
                                  border: "1px solid rgba(224, 224, 224, 1)", // Header gridlines
                                  width: "15%",
                                }}
                                align="center"
                              >
                                Customer Name
                              </TableCell>
                            )}

                            {
                              <TableCell
                                sx={{
                                  fontWeight: "bold",
                                  padding: 0.5,
                                  fontSize: "0.9rem",
                                  color: "#333",
                                  border: "1px solid rgba(224, 224, 224, 1)", // Header gridlines
                                  width: "15%",
                                }}
                                align="center"
                              >
                                Action
                              </TableCell>
                            }

                            <TableCell
                              sx={{
                                fontWeight: "bold",
                                padding: 0.5,
                                fontSize: "0.9rem",
                                color: "#333",
                                border: "1px solid rgba(224, 224, 224, 1)", // Header gridlines
                                width: "15%",
                              }}
                              align="center"
                            >
                              Check In
                            </TableCell>

                            <TableCell
                              sx={{
                                fontWeight: "bold",
                                padding: 0.5,
                                fontSize: "0.9rem",
                                color: "#333",
                                border: "1px solid rgba(224, 224, 224, 1)", // Header gridlines
                                width: "15%",
                              }}
                              align="center"
                            >
                              Check Out
                            </TableCell>
                          </TableRow>
                        </TableHead>

                        {/* Table Body */}
                        <TableBody>
                          {section.tasks.map((task, idx) => (
                            <React.Fragment key={task.id}>
                              <TableRow
                                sx={{
                                  backgroundColor:
                                    idx % 2 === 0 ? "#FFFFFF" : "#F9FAFB", // Striped rows
                                  "&:hover": { backgroundColor: "#F1F5F9" }, // Hover effect
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  if (
                                    (task.specific_action === "Meeting" ||
                                      task.specific_action ===
                                        "Meeting_Office" ||
                                      task.specific_action ===
                                        "Meeting_Field" ||
                                      task.specific_action === "Site Visit") &&
                                    task.travel_details?.checkout_time ===
                                      null &&
                                    Object.keys(task.travel_details1).length ===
                                      0
                                  ) {
                                    onRowClick(task);
                                  } else if (
                                    task.specific_action ===
                                      "On Call Discussion" &&
                                    task.completion_status != "completed"
                                  ) {
                                    onRowClick(task);
                                  } else if (
                                    task.specific_action === "Group Meeting" &&
                                    task.travel_details?.checkout_time === null
                                  ) {
                                    navigate("/groupMeeting/add", {
                                      state: {
                                        travelDetailId:
                                          task.travel_details?.travel_detailsId,
                                        bdmLeadActionId: task.id,
                                      },
                                    });
                                  } else if (
                                    (task.specific_action === "HO Visit" ||
                                      task.specific_action === "RO Visit" ||
                                      task.specific_action === "BO Visit" ||
                                      task.specific_action === "Travel") &&
                                    task.travel_details?.checkout_time ===
                                      null &&
                                    task.completion_status !== "completed"
                                  ) {
                                    setOpenVisitFormsDialog(true);
                                    setTypeOfTask(task.specific_action);
                                    setBdmLeadActionId(task.id);
                                  } else if ((task.specific_action === "Farm Visit" || task.specific_action === "Head Office Visit") &&  task.travel_details?.checkout_time ===
                                      null) {
                                        setTypeOfTask(task.specific_action);
                                        setBdmLeadActionId(task.id);
                                    setOpenTaskDialog(true);
                                  }
                                }}
                              >
                                <TableCell sx={{ padding: 1, width: "5%" }}>
                                  <IconButton
                                    size="small"
                                    onClick={(event) => {
                                      event.stopPropagation(); // Prevents row click
                                      toggleRow(task.id);
                                    }}
                                    sx={{ fontSize: "0.8rem" }}
                                  >
                                    {idx + 1}
                                    {expandedRow === task.id ? (
                                      <KeyboardArrowUp />
                                    ) : (
                                      <KeyboardArrowDown />
                                    )}
                                  </IconButton>
                                </TableCell>
                                <TableCell
                                  sx={{
                                    fontSize: isMobile ? "0.8rem" : "1rem",
                                    padding: 0.4,
                                    width: "15%",
                                  }}
                                >
                                  {section.title !== "Other Tasks" ? (
                                    task.CustomerName
                                  ) : (
                                    <>
                                      {task.task_name}
                                      <br />
                                      {task.task_name != "Other" &&
                                        task.task_name != "Agreement" &&
                                        task.task_name !=
                                          "Complaint/ Service" && (
                                          <Typography
                                            variant="caption"
                                            sx={{
                                              color:
                                                task.completion_status === null
                                                  ? "red"
                                                  : "green",
                                            }}
                                          >
                                            {task.completion_status === null
                                              ? "Not-Completed"
                                              : "Completed"}
                                          </Typography>
                                        )}
                                    </>
                                  )}
                                </TableCell>

                                {section.title !== "Other Tasks" && (
                                  <TableCell
                                    sx={{
                                      color:
                                        task.specific_action === "Postpone"
                                          ? "red"
                                          : "",
                                      fontSize: isMobile ? "0.8rem" : "1rem",
                                      padding: 0.5,
                                      width: "15%",
                                    }}
                                  >
                                    {task.specific_action ? (
                                      <>
                                        {task.specific_action}
                                        <br />
                                        <Typography
                                          variant="caption"
                                          sx={{
                                            color:
                                              task.completion_status === null
                                                ? "red"
                                                : "green",
                                          }}
                                        >
                                          (
                                          {task.completion_status === null ? (
                                            task.travel_details1?.syncing ? (
                                              <Chip
                                                size="small"
                                                label={"Syncing.."}
                                                color={"warning"}
                                              ></Chip>
                                            ) : (
                                              "Not-Completed"
                                            )
                                          ) : (
                                            "Completed"
                                          )}
                                          )
                                        </Typography>
                                      </>
                                    ) : (
                                      <Typography
                                        color="error"
                                        sx={{
                                          fontSize: isMobile
                                            ? "0.8rem"
                                            : "1rem",
                                        }}
                                      >
                                        Postpone
                                      </Typography>
                                    )}
                                  </TableCell>
                                )}

                                {section.title === "Other Tasks" ? (
                                  <TableCell
                                    align="center"
                                    sx={{ padding: 1, width: "15%" }}
                                  >
                                    {task.action_type !== "postpone" &&
                                      (task.specific_action === "HO Visit" ||
                                        task.specific_action === "RO Visit" ||
                                        task.specific_action === "Expo Event" ||
                                        task.specific_action === "BO Visit" ||
                                        task.specific_action === "Travel" ||
                                        task.specific_action ===
                                          "Group Meeting" ||
                                        task.specific_action === "Farm Visit" ||
                                        task.specific_action ===
                                          "Head Office Visit") &&
                                      (task.travel_details?.checkin_time ? (
                                        <Tooltip title="Check-In" arrow>
                                          <Typography
                                            sx={{
                                              fontSize: isMobile
                                                ? "0.8rem"
                                                : "1rem",
                                            }}
                                          >
                                            {task.travel_details?.checkin_time}
                                          </Typography>
                                        </Tooltip>
                                      ) : (
                                        <Tooltip
                                          title={
                                            isPreviousCheckoutMissing(task.id)
                                              ? "Please check out the previous task before checking in."
                                              : "Check-In"
                                          }
                                          arrow
                                        >
                                          <span>
                                            <IconButton
                                              size="small"
                                              onClick={(event) => {
                                                event.stopPropagation();
                                                if (
                                                  isPreviousCheckoutMissing(
                                                    task.id
                                                  )
                                                ) {
                                                  if (isMobile) {
                                                    setSeverity("error");
                                                    setMessage(
                                                      "Please check out the previous task before checking in."
                                                    );
                                                    setOpenSnackbar(true);
                                                  }
                                                } else {
                                                  handleCheckIn(task);
                                                }
                                              }}
                                              disabled={
                                                !isMobile &&
                                                isPreviousCheckoutMissing(
                                                  task.id
                                                )
                                              }
                                            >
                                              <CircleCheck color="green" />
                                            </IconButton>
                                          </span>
                                        </Tooltip>
                                      ))}
                                  </TableCell>
                                ) : (
                                  <TableCell
                                    align="center"
                                    sx={{ padding: 1, width: "15%" }}
                                  >
                                    {task.action_type !== "postpone" &&
                                      task.specific_action !== null &&
                                      task.specific_action !==
                                        "On Call Discussion" &&
                                      task.specific_action !==
                                        "Estimation Request" &&
                                      (task.travel_details?.checkin_time ||
                                      task.travel_details1?.checkIntime ? (
                                        <Tooltip title="Check-In" arrow>
                                          <Typography
                                            sx={{
                                              fontSize: isMobile
                                                ? "0.8rem"
                                                : "1rem",
                                            }}
                                          >
                                            {task.travel_details
                                              ?.checkin_time ||
                                              task.travel_details1?.checkIntime}
                                          </Typography>
                                        </Tooltip>
                                      ) : (
                                        <Tooltip
                                          title={
                                            isPreviousCheckoutMissing(task.id)
                                              ? "Please check out the previous task before checking in."
                                              : "Check-In"
                                          }
                                          arrow
                                        >
                                          <span>
                                            <IconButton
                                              size="small"
                                              onClick={(event) => {
                                                event.stopPropagation();
                                                if (
                                                  isPreviousCheckoutMissing(
                                                    task.id
                                                  )
                                                ) {
                                                  if (isMobile) {
                                                    setSeverity("error");
                                                    setMessage(
                                                      "Please check out the previous task before checking in."
                                                    );
                                                    setOpenSnackbar(true);
                                                  }
                                                } else {
                                                  handleCheckIn(task);
                                                }
                                              }}
                                              disabled={
                                                !isMobile &&
                                                isPreviousCheckoutMissing(
                                                  task.id
                                                )
                                              }
                                            >
                                              <CircleCheck color="green" />
                                            </IconButton>
                                          </span>
                                        </Tooltip>
                                      ))}
                                  </TableCell>
                                )}

                                {section.title === "Other Tasks" ? (
                                  <TableCell
                                    align="center"
                                    sx={{ padding: 1, width: "15%" }}
                                  >
                                    {(task.specific_action === "HO Visit" ||
                                      task.specific_action === "RO Visit" ||
                                      task.specific_action === "Expo Event" ||
                                      task.specific_action === "BO Visit" ||
                                      task.specific_action === "Travel" ||
                                      task.specific_action ===
                                        "Group Meeting" ||
                                      task.specific_action === "Farm Visit" ||
                                      task.specific_action ===
                                        "Head Office Visit") &&
                                      task.travel_details?.checkin_time && // Ensure check-in time is available
                                      (task.travel_details?.checkout_time ||
                                      (task.travel_details1?.checkout_time &&
                                        task.travel_details1?.type !==
                                          "check_in") ? (
                                        <Tooltip title="Check-Out" arrow>
                                          <Typography
                                            sx={{
                                              fontSize: isMobile
                                                ? "0.8rem"
                                                : "1rem",
                                            }}
                                          >
                                            {task.travel_details
                                              ?.checkout_time ||
                                              task.travel_details1
                                                ?.checkout_time}
                                          </Typography>
                                        </Tooltip>
                                      ) : (
                                        <Tooltip
                                          title={
                                            isPreviousCheckoutMissing(task.id)
                                              ? "Please check out the previous task before checking in."
                                              : task.completion_status ===
                                                  null &&
                                                (task.specific_action ===
                                                  "Travel" ||
                                                  task.specific_action ===
                                                    "HO Visit" ||
                                                  task.specific_action ===
                                                    "BO Visit" ||
                                                  task.specific_action ===
                                                    "RO Visit" || task.specific_action ===
                                                    "Farm Visit" || task.specific_action ===
                                                    "Head Office Visit")
                                              ? "Please complete the task before checking out."
                                              : "Check-Out"
                                          }
                                          arrow
                                        >
                                          {task.specific_action ===
                                          "Group Meeting" ? (
                                            <></>
                                          ) : (
                                            <span>
                                              <IconButton
                                                size="small"
                                                onClick={(event) => {
                                                  event.stopPropagation();

                                                  if (
                                                    isPreviousCheckoutMissing(
                                                      task.id
                                                    )
                                                  ) {
                                                    if (isMobile) {
                                                      setSeverity("error");
                                                      setMessage(
                                                        "Please check out the previous task before checking in."
                                                      );
                                                      setOpenSnackbar(true);
                                                    }
                                                  } else if (
                                                    task.completion_status ===
                                                      null &&
                                                    (task.specific_action ===
                                                      "Travel" ||
                                                      task.specific_action ===
                                                        "HO Visit" ||
                                                      task.specific_action ===
                                                        "BO Visit" ||
                                                      task.specific_action ===
                                                        "RO Visit" || task.specific_action ===
                                                    "Farm Visit" || task.specific_action ===
                                                    "Head Office Visit")
                                                  ) {
                                                    // Prevent checkout for incomplete tasks of specific types
                                                    setSeverity("error");
                                                    setMessage(
                                                      "Please complete the task before checking out."
                                                    );
                                                    setOpenSnackbar(true);
                                                  } else {
                                                    handleCheckout(task);
                                                  }
                                                }}
                                                disabled={
                                                  !isMobile &&
                                                  (isPreviousCheckoutMissing(
                                                    task.id
                                                  ) ||
                                                    (task.completion_status ===
                                                      null &&
                                                      (task.specific_action ===
                                                        "Travel" ||
                                                        task.specific_action ===
                                                          "HO Visit" ||
                                                        task.specific_action ===
                                                          "BO Visit" ||
                                                        task.specific_action ===
                                                          "RO Visit" || task.specific_action ===
                                                    "Farm Visit" || task.specific_action ===
                                                    "Head Office Visit")))
                                                }
                                              >
                                                <CircleCheck color="red" />
                                              </IconButton>
                                            </span>
                                          )}
                                        </Tooltip>
                                      ))}
                                  </TableCell>
                                ) : (
                                  <TableCell
                                    align="center"
                                    sx={{ padding: 1, width: "20%" }}
                                  >
                                    <Typography
                                      sx={{
                                        fontSize: isMobile ? "0.8rem" : "1rem",
                                      }}
                                    >
                                      {task.travel_details?.checkout_time ||
                                        task.travel_details1?.checkout_time ||
                                        "-"}
                                    </Typography>
                                  </TableCell>
                                )}
                              </TableRow>

                              {/* Expandable Row */}
                              {expandedRow === task.id && (
                                <TableRow>
                                  <TableCell colSpan={5} sx={{ padding: 1 }}>
                                    <Collapse
                                      in={expandedRow === task.id}
                                      timeout="auto"
                                      unmountOnExit
                                    >
                                      {task.specific_action ===
                                        "On Call Discussion" && (
                                        <Box
                                          sx={{
                                            p: 1,
                                            bgcolor: "gray.100",
                                            borderRadius: "8px",
                                            display: "flex",
                                            flexDirection: isMobile
                                              ? "column"
                                              : "row",
                                            gap: 2,
                                          }}
                                        >
                                          {/* Flex container for each label/data pair */}

                                          <Box
                                            sx={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                              width: "100%",
                                            }}
                                          >
                                            <Typography
                                              variant="body2"
                                              gutterBottom
                                            >
                                              <strong>Customer Name:</strong>
                                            </Typography>
                                            <Typography
                                              variant="body2"
                                              gutterBottom
                                            >
                                              {task.CustomerName}
                                            </Typography>
                                          </Box>

                                          <Box
                                            sx={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                              width: "100%",
                                            }}
                                          >
                                            <Typography
                                              variant="body2"
                                              gutterBottom
                                            >
                                              <strong>Location:</strong>
                                            </Typography>
                                            <Typography
                                              variant="body2"
                                              gutterBottom
                                            >
                                              {task.location}
                                            </Typography>
                                          </Box>

                                          <Box
                                            sx={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                              width: "100%",
                                            }}
                                          >
                                            <Typography
                                              variant="body2"
                                              gutterBottom
                                            >
                                              <strong>Mobile Number:</strong>
                                            </Typography>
                                            <Typography
                                              variant="body2"
                                              gutterBottom
                                            >
                                              {task.MobileNo}
                                            </Typography>
                                          </Box>

                                          <Box
                                            sx={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                              width: "100%",
                                            }}
                                          >
                                            <Typography
                                              variant="body2"
                                              gutterBottom
                                            >
                                              <strong>Category:</strong>
                                            </Typography>
                                            <Typography
                                              variant="body2"
                                              gutterBottom
                                              sx={{
                                                textTransform: "capitalize",
                                              }}
                                            >
                                              {task.category}
                                            </Typography>
                                          </Box>

                                          <Box
                                            sx={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                              width: "100%",
                                            }}
                                          >
                                            <Typography
                                              variant="body2"
                                              gutterBottom
                                            >
                                              <strong>Sub Category:</strong>
                                            </Typography>
                                            <Typography
                                              variant="body2"
                                              gutterBottom
                                            >
                                              {task.sub_category}
                                            </Typography>
                                          </Box>

                                          <Box
                                            sx={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                              width: "100%",
                                            }}
                                          >
                                            <Typography
                                              variant="body2"
                                              gutterBottom
                                            >
                                              <strong>Remarks:</strong>
                                            </Typography>
                                            <Typography
                                              variant="body2"
                                              gutterBottom
                                            >
                                              {task.remark}
                                            </Typography>
                                          </Box>
                                        </Box>
                                      )}

                                      {task.specific_action ===
                                        "Meeting_Office" && (
                                        <Box
                                          sx={{
                                            p: 1,
                                            bgcolor: "gray.100",
                                            borderRadius: "8px",
                                            display: "flex",
                                            flexDirection: isMobile
                                              ? "column"
                                              : "row",
                                            gap: 2,
                                          }}
                                        >
                                          {/* Flex container for each label/data pair */}

                                          <Box
                                            sx={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                              width: "100%",
                                            }}
                                          >
                                            <Typography
                                              variant="body2"
                                              gutterBottom
                                            >
                                              <strong>Customer Name:</strong>
                                            </Typography>
                                            <Typography
                                              variant="body2"
                                              gutterBottom
                                            >
                                              {task.CustomerName}
                                            </Typography>
                                          </Box>

                                          <Box
                                            sx={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                              width: "100%",
                                            }}
                                          >
                                            <Typography
                                              variant="body2"
                                              gutterBottom
                                            >
                                              <strong>Location:</strong>
                                            </Typography>
                                            <Typography
                                              variant="body2"
                                              gutterBottom
                                            >
                                              {task.location}
                                            </Typography>
                                          </Box>

                                          {task.regionalOffice && (
                                            <Box
                                              sx={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                width: "100%",
                                              }}
                                            >
                                              <Typography
                                                variant="body2"
                                                gutterBottom
                                              >
                                                <strong>
                                                  Regional Office:
                                                </strong>
                                              </Typography>
                                              <Typography
                                                variant="body2"
                                                gutterBottom
                                              >
                                                {task.regionalOffice}
                                              </Typography>
                                            </Box>
                                          )}

                                          {task.branchOffice && (
                                            <Box
                                              sx={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                width: "100%",
                                              }}
                                            >
                                              <Typography
                                                variant="body2"
                                                gutterBottom
                                              >
                                                <strong>Branch Office:</strong>
                                              </Typography>
                                              <Typography
                                                variant="body2"
                                                gutterBottom
                                              >
                                                {task.branchOffice}
                                              </Typography>
                                            </Box>
                                          )}

                                          <Box
                                            sx={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                              width: "100%",
                                            }}
                                          >
                                            <Typography
                                              variant="body2"
                                              gutterBottom
                                            >
                                              <strong>Mobile Number:</strong>
                                            </Typography>
                                            <Typography
                                              variant="body2"
                                              gutterBottom
                                            >
                                              {task.MobileNo}
                                            </Typography>
                                          </Box>

                                          <Box
                                            sx={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                              width: "100%",
                                            }}
                                          >
                                            <Typography
                                              variant="body2"
                                              gutterBottom
                                            >
                                              <strong>Category:</strong>
                                            </Typography>
                                            <Typography
                                              variant="body2"
                                              gutterBottom
                                              sx={{
                                                textTransform: "capitalize",
                                              }}
                                            >
                                              {task.category}
                                            </Typography>
                                          </Box>

                                          <Box
                                            sx={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                              width: "100%",
                                            }}
                                          >
                                            <Typography
                                              variant="body2"
                                              gutterBottom
                                            >
                                              <strong>Sub Category:</strong>
                                            </Typography>
                                            <Typography
                                              variant="body2"
                                              gutterBottom
                                            >
                                              {task.sub_category}
                                            </Typography>
                                          </Box>

                                          <Box
                                            sx={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                              width: "100%",
                                            }}
                                          >
                                            <Typography
                                              variant="body2"
                                              gutterBottom
                                            >
                                              <strong>Remarks:</strong>
                                            </Typography>
                                            <Typography
                                              variant="body2"
                                              gutterBottom
                                            >
                                              {task.remark}
                                            </Typography>
                                          </Box>
                                        </Box>
                                      )}

                                      {task.specific_action ===
                                        "Meeting_Field" && (
                                        <Box
                                          sx={{
                                            p: 1,
                                            bgcolor: "gray.100",
                                            borderRadius: "8px",
                                            display: "flex",
                                            flexDirection: isMobile
                                              ? "column"
                                              : "row",
                                            gap: 2,
                                          }}
                                        >
                                          {/* Flex container for each label/data pair */}

                                          <Box
                                            sx={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                              width: "100%",
                                            }}
                                          >
                                            <Typography
                                              variant="body2"
                                              gutterBottom
                                            >
                                              <strong>Customer Name:</strong>
                                            </Typography>
                                            <Typography
                                              variant="body2"
                                              gutterBottom
                                            >
                                              {task.CustomerName}
                                            </Typography>
                                          </Box>

                                          <Box
                                            sx={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                              width: "100%",
                                            }}
                                          >
                                            <Typography
                                              variant="body2"
                                              gutterBottom
                                            >
                                              <strong>Location:</strong>
                                            </Typography>
                                            <Typography
                                              variant="body2"
                                              gutterBottom
                                            >
                                              {task.location}
                                            </Typography>
                                          </Box>

                                          <Box
                                            sx={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                              width: "100%",
                                            }}
                                          >
                                            <Typography
                                              variant="body2"
                                              gutterBottom
                                            >
                                              <strong>Mobile Number:</strong>
                                            </Typography>
                                            <Typography
                                              variant="body2"
                                              gutterBottom
                                            >
                                              {task.MobileNo}
                                            </Typography>
                                          </Box>

                                          <Box
                                            sx={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                              width: "100%",
                                            }}
                                          >
                                            <Typography
                                              variant="body2"
                                              gutterBottom
                                            >
                                              <strong>Category:</strong>
                                            </Typography>
                                            <Typography
                                              variant="body2"
                                              gutterBottom
                                              sx={{
                                                textTransform: "capitalize",
                                              }}
                                            >
                                              {task.category}
                                            </Typography>
                                          </Box>

                                          <Box
                                            sx={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                              width: "100%",
                                            }}
                                          >
                                            <Typography
                                              variant="body2"
                                              gutterBottom
                                            >
                                              <strong>Sub Category:</strong>
                                            </Typography>
                                            <Typography
                                              variant="body2"
                                              gutterBottom
                                            >
                                              {task.sub_category}
                                            </Typography>
                                          </Box>

                                          <Box
                                            sx={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                              width: "100%",
                                            }}
                                          >
                                            <Typography
                                              variant="body2"
                                              gutterBottom
                                            >
                                              <strong>Remarks:</strong>
                                            </Typography>
                                            <Typography
                                              variant="body2"
                                              gutterBottom
                                            >
                                              {task.remark}
                                            </Typography>
                                          </Box>
                                        </Box>
                                      )}

                                      {(task.specific_action ===
                                          "Farm Visit" || task.specific_action ===
                                          "Head Office Visit") && (
                                        <Box
                                          sx={{
                                            p: 1,
                                            bgcolor: "gray.100",
                                            borderRadius: "8px",
                                            display: "flex",
                                            flexDirection: isMobile
                                              ? "column"
                                              : "row",
                                            gap: 2,
                                          }}
                                        >
                                          {/* Flex container for each label/data pair */}

                                          <Box
                                            sx={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                              width: "100%",
                                            }}
                                          >
                                            <Typography
                                              variant="body2"
                                              gutterBottom
                                            >
                                              <strong>Farm Name:</strong>
                                            </Typography>
                                            <Typography
                                              variant="body2"
                                              gutterBottom
                                            >
                                              {task?.travel_form_details?.farmName || "-"}
                                            </Typography>
                                          </Box>

                                          <Box
                                            sx={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                              width: "100%",
                                            }}
                                          >
                                            <Typography
                                              variant="body2"
                                              gutterBottom
                                            >
                                              <strong>Observation:</strong>
                                            </Typography>
                                            <Typography
                                              variant="body2"
                                              gutterBottom
                                            >
                                              {task?.travel_form_details?.observation || "-"}
                                            </Typography>
                                          </Box>

                                          <Box
                                            sx={{
                                              display: "flex",
                                              alignItems: "center",
                                              justifyContent: "space-between",
                                              mt: 1,
                                            }}
                                          >
                                            <Typography variant="body2">
                                              <strong>Visit Image:</strong>
                                            </Typography>

                                            {task?.travel_form_details
                                              ?.mandatoryVisitImage ? (
                                              <IconButton
                                                onClick={() =>
                                                  handleImageClick(
                                                    task.travel_form_details
                                                      .mandatoryVisitImage
                                                  )
                                                }
                                              >
                                                <Box
                                                  component="span"
                                                  sx={{
                                                    cursor: "pointer",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    "&:hover": {
                                                      color: "primary.main",
                                                    },
                                                  }}
                                                  onClick={() => {
                                                    setSelectedImage(
                                                      task.travel_form_details
                                                        .mandatoryVisitImage
                                                    );
                                                    setOpenImageDialog(true);
                                                  }}
                                                >
                                                  <Image />
                                                </Box>
                                              </IconButton>
                                            ) : (
                                              <Typography variant="body2">
                                                No image
                                              </Typography>
                                            )}
                                          </Box>

                                          {/* Optional Visit Image */}
                                          <Box
                                            sx={{
                                              display: "flex",
                                              alignItems: "center",
                                              justifyContent: "space-between",
                                            }}
                                          >
                                            <Typography variant="body2">
                                              <strong>
                                                Optional Visit Image:
                                              </strong>
                                            </Typography>
                                            {task?.travel_form_details
                                              ?.optionalVisitImage ? (
                                              <Box
                                                component="span"
                                                sx={{
                                                  cursor: "pointer",
                                                  display: "flex",
                                                  alignItems: "center",
                                                  "&:hover": {
                                                    color: "primary.main",
                                                  },
                                                }}
                                                onClick={() => {
                                                  setSelectedImage(
                                                    task.travel_form_details
                                                      .optionalVisitImage
                                                  );
                                                  setOpenImageDialog(true);
                                                }}
                                              >
                                                <Image />
                                              </Box>
                                            ) : (
                                              <Typography variant="body2">
                                                No image
                                              </Typography>
                                            )}
                                          </Box>
                                        </Box>
                                      )}

                                      {task.specific_action === "Travel" && (
                                        <Box
                                          sx={{
                                            p: 1,
                                            bgcolor: "gray.100",
                                            borderRadius: "8px",
                                            display: "flex",
                                            flexDirection: isMobile
                                              ? "column"
                                              : "row",
                                            gap: 2,
                                          }}
                                        >
                                          {/* Flex container for each label/data pair */}

                                          <Box
                                            sx={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                              width: "100%",
                                            }}
                                          >
                                            <Typography
                                              variant="body2"
                                              gutterBottom
                                            >
                                              <strong>Mode of Travel:</strong>
                                            </Typography>
                                            <Typography
                                              variant="body2"
                                              gutterBottom
                                              sx={{
                                                textTransform: "capitalize",
                                              }}
                                            >
                                              {task?.travel_form_details
                                                ?.modeOfTravel || "-"}
                                            </Typography>
                                          </Box>

                                          <Box
                                            sx={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                              width: "100%",
                                            }}
                                          >
                                            <Typography
                                              variant="body2"
                                              gutterBottom
                                            >
                                              <strong>Purpose:</strong>
                                            </Typography>
                                            <Typography
                                              variant="body2"
                                              gutterBottom
                                            >
                                              {task?.travel_form_details
                                                ?.reasonForTravel || "-"}
                                            </Typography>
                                          </Box>

                                          <Box
                                            sx={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                              width: "100%",
                                            }}
                                          >
                                            <Typography
                                              variant="body2"
                                              gutterBottom
                                            >
                                              <strong>From:</strong>
                                            </Typography>
                                            <Typography
                                              variant="body2"
                                              gutterBottom
                                            >
                                              {task?.travel_form_details
                                                ?.travelFrom || "-"}
                                            </Typography>
                                          </Box>

                                          <Box
                                            sx={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                              width: "100%",
                                            }}
                                          >
                                            <Typography
                                              variant="body2"
                                              gutterBottom
                                            >
                                              <strong>To:</strong>
                                            </Typography>
                                            <Typography
                                              variant="body2"
                                              gutterBottom
                                              sx={{
                                                textTransform: "capitalize",
                                              }}
                                            >
                                              {task?.travel_form_details
                                                ?.travelTo || "-"}
                                            </Typography>
                                          </Box>

                                          <Box
                                            sx={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                              width: "100%",
                                              flexWrap: "wrap",
                                            }}
                                          >
                                            <Typography
                                              variant="body2"
                                              gutterBottom
                                            >
                                              <strong>Remarks:</strong>
                                            </Typography>
                                            <Typography
                                              variant="body2"
                                              gutterBottom
                                              sx={{
                                                wordBreak: "break-word", // Wrap long words
                                                maxWidth: "100%", // Ensures it doesn't overflow the container
                                              }}
                                            >
                                              {task?.travel_form_details
                                                ?.remarks || "-"}
                                            </Typography>
                                          </Box>

                                          <Box
                                            sx={{
                                              display: "flex",
                                              alignItems: "center",
                                              justifyContent: "space-between",
                                              mt: 1,
                                            }}
                                          >
                                            <Typography variant="body2">
                                              <strong>Visit Image:</strong>
                                            </Typography>

                                            {task?.travel_form_details
                                              ?.mandatoryVisitImage ? (
                                              <IconButton
                                                onClick={() =>
                                                  handleImageClick(
                                                    task.travel_form_details
                                                      .mandatoryVisitImage
                                                  )
                                                }
                                              >
                                                <Box
                                                  component="span"
                                                  sx={{
                                                    cursor: "pointer",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    "&:hover": {
                                                      color: "primary.main",
                                                    },
                                                  }}
                                                  onClick={() => {
                                                    setSelectedImage(
                                                      task.travel_form_details
                                                        .mandatoryVisitImage
                                                    );
                                                    setOpenImageDialog(true);
                                                  }}
                                                >
                                                  <Image />
                                                </Box>
                                              </IconButton>
                                            ) : (
                                              <Typography variant="body2">
                                                No image
                                              </Typography>
                                            )}
                                          </Box>

                                          {/* Optional Visit Image */}
                                          <Box
                                            sx={{
                                              display: "flex",
                                              alignItems: "center",
                                              justifyContent: "space-between",
                                            }}
                                          >
                                            <Typography variant="body2">
                                              <strong>
                                                Optional Visit Image:
                                              </strong>
                                            </Typography>
                                            {task?.travel_form_details
                                              ?.optionalVisitImage ? (
                                              <Box
                                                component="span"
                                                sx={{
                                                  cursor: "pointer",
                                                  display: "flex",
                                                  alignItems: "center",
                                                  "&:hover": {
                                                    color: "primary.main",
                                                  },
                                                }}
                                                onClick={() => {
                                                  setSelectedImage(
                                                    task.travel_form_details
                                                      .optionalVisitImage
                                                  );
                                                  setOpenImageDialog(true);
                                                }}
                                              >
                                                <Image />
                                              </Box>
                                            ) : (
                                              <Typography variant="body2">
                                                No image
                                              </Typography>
                                            )}
                                          </Box>
                                        </Box>
                                      )}

                                      {(task.specific_action === "Agreement" ||
                                        task.specific_action ===
                                          "Complaint/ Service" ||
                                        task.specific_action === "Other" ||
                                        task.specific_action === "Expo Event" ||
                                        task.specific_action ===
                                          "Group Meeting" ) && (
                                        <Box
                                          sx={{
                                            p: 1,
                                            bgcolor: "gray.100",
                                            borderRadius: "8px",
                                            display: "flex",
                                            flexDirection: isMobile
                                              ? "column"
                                              : "row",
                                            gap: 2,
                                          }}
                                        >
                                          {/* Flex container for each label/data pair */}

                                          <Box
                                            sx={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                              width: "100%",
                                            }}
                                          >
                                            <Typography
                                              variant="body2"
                                              gutterBottom
                                            >
                                              <strong>Remarks:</strong>
                                            </Typography>
                                            <Typography
                                              variant="body2"
                                              gutterBottom
                                              sx={{
                                                textTransform: "capitalize",
                                              }}
                                            >
                                              {task.bdm_remark || "-"}
                                            </Typography>
                                          </Box>
                                        </Box>
                                      )}

                                      {task.specific_action === "HO Visit" && (
                                        <Box
                                          sx={{
                                            p: 1,
                                            bgcolor: "gray.100",
                                            borderRadius: "8px",
                                            display: "flex",
                                            flexDirection: isMobile
                                              ? "column"
                                              : "row",
                                            gap: 2,
                                          }}
                                        >
                                          <Box
                                            sx={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                              width: "100%",
                                            }}
                                          >
                                            <Typography
                                              variant="body2"
                                              gutterBottom
                                            >
                                              <strong>Purpose:</strong>
                                            </Typography>
                                            <Typography
                                              variant="body2"
                                              gutterBottom
                                              sx={{
                                                textTransform: "capitalize",
                                              }}
                                            >
                                              {task?.travel_form_details
                                                ?.hoSelection || "-"}
                                            </Typography>
                                          </Box>

                                          <Box
                                            sx={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                              width: "100%",
                                              flexWrap: "wrap",
                                            }}
                                          >
                                            <Typography
                                              variant="body2"
                                              gutterBottom
                                            >
                                              <strong>Remarks:</strong>
                                            </Typography>
                                            <Typography
                                              variant="body2"
                                              gutterBottom
                                              sx={{
                                                wordBreak: "break-word", // Wrap long words
                                                maxWidth: "100%", // Ensures it doesn't overflow the container
                                              }}
                                            >
                                              {task?.travel_form_details
                                                ?.remarks || "-"}
                                            </Typography>
                                          </Box>

                                          <Box
                                            sx={{
                                              display: "flex",
                                              alignItems: "center",
                                              justifyContent: "space-between",
                                              mt: 1,
                                            }}
                                          >
                                            <Typography variant="body2">
                                              <strong>Visit Image:</strong>
                                            </Typography>

                                            {task?.travel_form_details
                                              ?.mandatoryVisitImage ? (
                                              <IconButton
                                                onClick={() =>
                                                  handleImageClick(
                                                    task.travel_form_details
                                                      .mandatoryVisitImage
                                                  )
                                                }
                                              >
                                                <Box
                                                  component="span"
                                                  sx={{
                                                    cursor: "pointer",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    "&:hover": {
                                                      color: "primary.main",
                                                    },
                                                  }}
                                                  onClick={() => {
                                                    setSelectedImage(
                                                      task.travel_form_details
                                                        .mandatoryVisitImage
                                                    );
                                                    setOpenImageDialog(true);
                                                  }}
                                                >
                                                  <Image />
                                                </Box>
                                              </IconButton>
                                            ) : (
                                              <Typography variant="body2">
                                                No image
                                              </Typography>
                                            )}
                                          </Box>

                                          {/* Optional Visit Image */}
                                          <Box
                                            sx={{
                                              display: "flex",
                                              alignItems: "center",
                                              justifyContent: "space-between",
                                            }}
                                          >
                                            <Typography variant="body2">
                                              <strong>
                                                Optional Visit Image:
                                              </strong>
                                            </Typography>
                                            {task?.travel_form_details
                                              ?.optionalVisitImage ? (
                                              <Box
                                                component="span"
                                                sx={{
                                                  cursor: "pointer",
                                                  display: "flex",
                                                  alignItems: "center",
                                                  "&:hover": {
                                                    color: "primary.main",
                                                  },
                                                }}
                                                onClick={() => {
                                                  setSelectedImage(
                                                    task.travel_form_details
                                                      .optionalVisitImage
                                                  );
                                                  setOpenImageDialog(true);
                                                }}
                                              >
                                                <Image />
                                              </Box>
                                            ) : (
                                              <Typography variant="body2">
                                                No image
                                              </Typography>
                                            )}
                                          </Box>
                                        </Box>
                                      )}

                                      {(task.specific_action === "RO Visit" ||
                                        task.specific_action ===
                                          "BO Visit") && (
                                        <Box
                                          sx={{
                                            p: 1,
                                            bgcolor: "gray.100",
                                            borderRadius: "8px",
                                            display: "flex",
                                            flexDirection: isMobile
                                              ? "column"
                                              : "row",
                                            gap: 2,
                                          }}
                                        >
                                          {/* Flex container for each label/data pair */}

                                          {task.specific_action ===
                                            "RO Visit" && (
                                            <Box
                                              sx={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                width: "100%",
                                              }}
                                            >
                                              <Typography
                                                variant="body2"
                                                gutterBottom
                                              >
                                                <strong>
                                                  Regional Office:
                                                </strong>
                                              </Typography>
                                              <Typography
                                                variant="body2"
                                                gutterBottom
                                                sx={{
                                                  textTransform: "capitalize",
                                                }}
                                              >
                                                {task?.travel_form_details
                                                  ?.regionalOfficeName || "-"}
                                              </Typography>
                                            </Box>
                                          )}

                                          {task.specific_action ===
                                            "BO Visit" && (
                                            <Box
                                              sx={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                width: "100%",
                                              }}
                                            >
                                              <Typography
                                                variant="body2"
                                                gutterBottom
                                              >
                                                <strong>Branch Office:</strong>
                                              </Typography>
                                              <Typography
                                                variant="body2"
                                                gutterBottom
                                                sx={{
                                                  textTransform: "capitalize",
                                                }}
                                              >
                                                {task?.travel_form_details
                                                  ?.branchName || "-"}
                                              </Typography>
                                            </Box>
                                          )}

                                          <Box
                                            sx={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                              width: "100%",
                                            }}
                                          >
                                            <Typography
                                              variant="body2"
                                              gutterBottom
                                            >
                                              <strong>Purpose:</strong>
                                            </Typography>
                                            <Typography
                                              variant="body2"
                                              gutterBottom
                                            >
                                              {task?.travel_form_details
                                                ?.purposeForVisit || "-"}
                                            </Typography>
                                          </Box>

                                          {task?.travel_form_details
                                            ?.purposeForVisit ===
                                            "Meeting_with_RH_BM_ZH" && (
                                            <Box
                                              sx={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                width: "100%",
                                              }}
                                            >
                                              <Typography
                                                variant="body2"
                                                gutterBottom
                                              >
                                                <strong>
                                                  Concern Person Name:
                                                </strong>
                                              </Typography>
                                              <Typography
                                                variant="body2"
                                                gutterBottom
                                                sx={{
                                                  textTransform: "capitalize",
                                                }}
                                              >
                                                {task?.travel_form_details
                                                  ?.concernPersonName || "-"}
                                              </Typography>
                                            </Box>
                                          )}

                                          {task?.travel_form_details
                                            ?.purposeForVisit ===
                                            "admin_work" && (
                                            <Box
                                              sx={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                width: "100%",
                                              }}
                                            >
                                              <Typography
                                                variant="body2"
                                                gutterBottom
                                              >
                                                <strong>Admin Task:</strong>
                                              </Typography>
                                              <Typography
                                                variant="body2"
                                                gutterBottom
                                                sx={{
                                                  textTransform: "capitalize",
                                                }}
                                              >
                                                {task?.travel_form_details
                                                  ?.adminTaskSelect || "-"}
                                              </Typography>
                                            </Box>
                                          )}

                                          <Box
                                            sx={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                              width: "100%",
                                              flexWrap: "wrap",
                                            }}
                                          >
                                            <Typography
                                              variant="body2"
                                              gutterBottom
                                            >
                                              <strong>Remarks:</strong>
                                            </Typography>
                                            <Typography
                                              variant="body2"
                                              gutterBottom
                                              sx={{
                                                wordBreak: "break-word", // Wrap long words
                                                maxWidth: "100%", // Ensures it doesn't overflow the container
                                              }}
                                            >
                                              {task?.travel_form_details
                                                ?.remarks || "-"}
                                            </Typography>
                                          </Box>

                                          <Box
                                            sx={{
                                              display: "flex",
                                              alignItems: "center",
                                              justifyContent: "space-between",
                                            }}
                                          >
                                            <Typography variant="body2">
                                              <strong>Visit Image1:</strong>
                                            </Typography>

                                            {task?.travel_form_details
                                              ?.mandatoryVisitImage ? (
                                              <IconButton
                                                onClick={() =>
                                                  handleImageClick(
                                                    task.travel_form_details
                                                      .mandatoryVisitImage
                                                  )
                                                }
                                              >
                                                <Box
                                                  component="span"
                                                  sx={{
                                                    cursor: "pointer",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    "&:hover": {
                                                      color: "primary.main",
                                                    },
                                                  }}
                                                  onClick={() => {
                                                    setSelectedImage(
                                                      task.travel_form_details
                                                        .mandatoryVisitImage
                                                    );
                                                    setOpenImageDialog(true);
                                                  }}
                                                >
                                                  <Image />
                                                </Box>
                                              </IconButton>
                                            ) : (
                                              <Typography variant="body2">
                                                No image
                                              </Typography>
                                            )}
                                          </Box>

                                          {/* Optional Visit Image */}
                                          <Box
                                            sx={{
                                              display: "flex",
                                              alignItems: "center",
                                              justifyContent: "space-between",
                                            }}
                                          >
                                            <Typography variant="body2">
                                              <strong>Visit Image2:</strong>
                                            </Typography>
                                            {task?.travel_form_details
                                              ?.optionalVisitImage ? (
                                              <Box
                                                component="span"
                                                sx={{
                                                  cursor: "pointer",
                                                  display: "flex",
                                                  alignItems: "center",
                                                  "&:hover": {
                                                    color: "primary.main",
                                                  },
                                                }}
                                                onClick={() => {
                                                  setSelectedImage(
                                                    task.travel_form_details
                                                      .optionalVisitImage
                                                  );
                                                  setOpenImageDialog(true);
                                                }}
                                              >
                                                <Image />
                                              </Box>
                                            ) : (
                                              <Typography variant="body2">
                                                No image
                                              </Typography>
                                            )}
                                          </Box>
                                        </Box>
                                      )}
                                    </Collapse>
                                  </TableCell>
                                </TableRow>
                              )}
                            </React.Fragment>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Box>
                </div>
              )
            );
          })}

          {/* Confirmation Dialog */}
          <Dialog open={openConfirmDialog} onClose={handleCloseDialog}>
            <DialogTitle>Confirm Check In</DialogTitle>
            <DialogContent>
              {loading ? (
                <Box display="flex" justifyContent="center" alignItems="center">
                  <CircularProgress />
                  <Typography sx={{ ml: 2 }}>Confirming...</Typography>
                </Box>
              ) : (
                <Typography>
                  Are you sure you want to check in for the task:{" "}
                  <strong>
                    {selectedTask
                      ? selectedTask.task_name
                        ? selectedTask.task_name
                        : selectedTask.CustomerName
                      : ""}
                  </strong>
                  ?
                </Typography>
              )}
            </DialogContent>
            <DialogActions>
              <Button
                onClick={handleCloseDialog}
                color="secondary"
                disabled={checkInLoading}
              >
                Cancel
              </Button>
              <Button
                onClick={confirmCheckIn}
                color="primary"
                variant="contained"
                disabled={checkInLoading}
              >
                {checkInLoading ? "Confirming..." : "Confirm"}
              </Button>
            </DialogActions>
          </Dialog>

          {/* Checkout Confirmation Dialog */}
          <Dialog open={openCheckoutDialog} onClose={handleCloseCheckoutDialog}>
            <DialogTitle>Confirm Check Out</DialogTitle>
            <DialogContent>
              <Typography>
                Are you sure you want to check out for the task:{" "}
                <strong>{checkoutTask ? checkoutTask.task_name : ""}</strong>?
              </Typography>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseCheckoutDialog} color="secondary">
                Cancel
              </Button>
              <Button
                onClick={confirmCheckout}
                color="primary"
                variant="contained"
                disabled={isCheckoutDone}
              >
                {isCheckoutDone ? "Confirming..." : "Confirm"}
              </Button>
            </DialogActions>
          </Dialog>
        </main>
      </div>

      {/* Add Task Dialog */}
      <Dialog
        open={addTaskDialog}
        onClose={handleCloseAddTaskDialog}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle
          sx={{
            background: (theme) => theme.palette.primary.main,
            color: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            fontWeight: "bold",
          }}
        >
          Add Task
          <IconButton
            aria-label="close"
            onClick={handleCloseAddTaskDialog}
            sx={{ color: "#fff" }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent sx={{ padding: "20px" }}>
          {/* Display Existing Other Tasks */}
          {otherTasks.length > 0 && (
            <div className="mt-4">
              <ul>
                {otherTasks.map((task) => (
                  <li key={task.id}>
                    <Typography>
                      <strong>{task.task_name}</strong> - {task.remarks}
                    </Typography>
                  </li>
                ))}
              </ul>
            </div>
          )}

          {/* Add New Other Task */}
          <Grid container spacing={2} alignItems="center" className="mt-4">
            <Grid item xs={6}>
              <FormControl fullWidth error={!!error}>
                <InputLabel>Select Other Task</InputLabel>
                <Select
                  value={selectedOtherTask}
                  onChange={(e) => {
                    setSelectedOtherTask(e.target.value);
                    setConfirmDisable(false);
                    setMobileNumber("");
                    setCustomerData([]);
                  }}
                  label="Select Other Task"
                >
                  <MenuItem value="">Select Task</MenuItem>
                  <MenuItem value="Meeting_Office">Meeting_Office</MenuItem>
                  <MenuItem value="Meeting_Field">Meeting_Field</MenuItem>
                  <MenuItem value="HO Visit">HO Visit</MenuItem>
                  <MenuItem value="RO Visit">RO Visit</MenuItem>
                  <MenuItem value="BO Visit">BO Visit</MenuItem>
                  <MenuItem value="Expo Event">Expo Event</MenuItem>
                  <MenuItem value="Travel">Travel</MenuItem>
                  <MenuItem value="Group Meeting">Group Meeting</MenuItem>
                  {/* <MenuItem value="Other">Other</MenuItem> */}
                </Select>
                {error && (
                  <Typography color="error" variant="body2">
                    {error}
                  </Typography>
                )}
              </FormControl>
            </Grid>

            {/* Mobile Number Field & Customer Data */}
            {["Site Visit", "Meeting_Office", "Meeting_Field"].includes(
              selectedOtherTask
            ) ? (
              <>
                <Grid item xs={6}>
                  <TextField
                    label="Mobile Number"
                    value={mobileNumber}
                    onChange={(e) => {
                      const numericValue = e.target.value.replace(
                        /[^0-9]/g,
                        ""
                      ); // Remove non-numeric characters
                      setMobileNumber(numericValue);

                      if (numericValue.length !== 10) {
                        setMobileNumberError(
                          "Mobile number must be exactly 10 digits."
                        );
                      } else {
                        setMobileNumberError("");
                        getDataByMobileNumber(numericValue);
                      }
                    }}
                    fullWidth
                    error={!!mobileNumberError}
                    helperText={mobileNumberError}
                    required
                    InputProps={{
                      inputProps: { maxLength: 10 },
                      endAdornment: mobileLoading && (
                        <InputAdornment position="end">
                          <CircularProgress size={20} />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>

                {/* Display Customer Name and Category if Data is Available */}
                {customerData && (
                  <Grid item xs={12}>
                    <Paper
                      elevation={3}
                      sx={{ padding: 2, backgroundColor: "#f9f9f9" }}
                    >
                      <Typography variant="body1">
                        <strong>Name:</strong>{" "}
                        {customerData.CustomerName || "N/A"}
                      </Typography>
                      <Typography variant="body1">
                        <strong>Category:</strong>{" "}
                        {customerData.category || "N/A"}
                      </Typography>
                    </Paper>
                  </Grid>
                )}

                {selectedOtherTask === "Meeting_Office" && (
                  <Grid item xs={12}>
                    <TextField
                      value={selectedTaskLocation}
                      onChange={(e) => {
                        console.log(e.target.value);

                        setSelectedTaskLocation(e.target.value);
                      }}
                      label="Select Location"
                      fullWidth
                      select
                    >
                      <MenuItem value={"ho"}>Head Office</MenuItem>
                      <MenuItem value={"ro"}>Regional Office</MenuItem>
                      <MenuItem value={"bo"}>Branch Office</MenuItem>
                    </TextField>
                  </Grid>
                )}

                {selectedTaskLocation === "bo" && (
                  <Grid item xs={12}>
                    <Autocomplete
                      options={branchList}
                      getOptionLabel={(option) => option.label}
                      value={
                        branchList.find((opt) => opt.label === branch) || null
                      }
                      onOpen={() => {
                        if (!branchList.length) {
                          getBOandROListByBdm(); // Fetch only if list is empty
                        }
                      }}
                      onChange={(event, newValue) =>
                        setBranch(newValue?.label || "")
                      }
                      loading={branchLoading}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select Branch Name"
                          fullWidth
                          InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                              <>
                                {branchLoading && (
                                  <CircularProgress color="inherit" size={20} />
                                )}
                                {params.InputProps.endAdornment}
                              </>
                            ),
                          }}
                        />
                      )}
                    />
                  </Grid>
                )}

                {selectedTaskLocation === "ro" && (
                  <Grid item xs={12}>
                    <Autocomplete
                      options={roList}
                      getOptionLabel={(option) => option.label}
                      value={
                        roList.find((opt) => opt.label === regionalOffice) ||
                        null
                      }
                      onOpen={() => {
                        if (!roList.length) {
                          getBOandROListByBdm(); // Fetch only if list is empty
                        }
                      }}
                      onChange={(event, newValue) =>
                        setRegionalOffice(newValue?.label || "")
                      }
                      loading={branchLoading}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select RO Name"
                          fullWidth
                          InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                              <>
                                {branchLoading && (
                                  <CircularProgress color="inherit" size={20} />
                                )}
                                {params.InputProps.endAdornment}
                              </>
                            ),
                          }}
                        />
                      )}
                    />
                  </Grid>
                )}
              </>
            ) : (
              <>
                {/* Show Remark and Add Task Button for other tasks */}
                <Grid item xs={6}>
                  <TextField
                    label="Remark"
                    value={remark}
                    onChange={(e) => {
                      const value = e.target.value;
                      setRemark(value);
                      if (value.trim().length < 5) {
                        setRemarkError("Remark must be at least 5 characters.");
                      } else {
                        setRemarkError("");
                      }
                    }}
                    fullWidth
                    required
                    error={!!remarkError}
                    helperText={remarkError}
                  />
                </Grid>

                {[
                  "HO Visit",
                  "RO Visit",
                  "Expo Event",
                  "BO Visit",
                  "Travel",
                  "Group Meeting",
                  "Farm Visit",
                ].includes(selectedOtherTask) ? (
                  <></>
                ) : (
                  <Grid item xs={2}>
                    {/* <Button
                      onClick={handleAddTask}
                      variant="contained"
                      color="primary"
                      fullWidth
                    >
                      +
                    </Button> */}
                  </Grid>
                )}
              </>
            )}
          </Grid>
        </DialogContent>
        <DialogActions>
          {[
            "Site Visit",
            "Meeting_Office",
            "Meeting_Field",
            "HO Visit",
            "RO Visit",
            "Expo Event",
            "BO Visit",
            "Travel",
            "Group Meeting",
          ].includes(selectedOtherTask) ? (
            <Button
              onClick={handleConfirmAction}
              disabled={sunmitLoading || confirmDisable}
            >
              {sunmitLoading ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                "Confirm"
              )}
            </Button>
          ) : (
            <Button onClick={handleSubmitNewTask} disabled={sunmitLoading}>
              {sunmitLoading ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                "Submit"
              )}
            </Button>
          )}
        </DialogActions>
      </Dialog>

      <Dialog
        open={addTaskDialog1}
        onClose={handleCloseAddTaskDialog}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle
          sx={{
            background: (theme) => theme.palette.primary.main,
            color: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            fontWeight: "bold",
          }}
        >
          Add Task
          <IconButton
            aria-label="close"
            onClick={handleCloseAddTaskDialog}
            sx={{ color: "#fff" }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent sx={{ padding: "20px" }}>
          {/* Display Existing Other Tasks */}
          {otherTasks.length > 0 && (
            <div className="mt-4">
              <ul>
                {otherTasks.map((task) => (
                  <li key={task.id}>
                    <Typography>
                      <strong>{task.task_name}</strong> - {task.remarks}
                    </Typography>
                  </li>
                ))}
              </ul>
            </div>
          )}

          {/* Add New Other Task */}
          <Grid container spacing={2} alignItems="center" className="mt-4">
            <Grid item xs={6}>
              <FormControl fullWidth error={!!error}>
                <InputLabel>Select Other Task</InputLabel>
                <Select
                  value={selectedOtherTask}
                  onChange={(e) => {
                    setSelectedOtherTask(e.target.value);
                  }}
                  label="Select Other Task"
                >
                  <MenuItem value="">Select Task</MenuItem>

                  <MenuItem value="Farm Visit">Farm Visit</MenuItem>
                  <MenuItem value="Head Office Visit">
                    Head Office Visit
                  </MenuItem>
                </Select>
                {error && (
                  <Typography color="error" variant="body2">
                    {error}
                  </Typography>
                )}
              </FormControl>
            </Grid>

            

            {/* Show Remark and Add Task Button for other tasks */}
            <Grid item xs={6}>
              <TextField
                label="Remark"
                value={remark}
                onChange={(e) => {
                  const value = e.target.value;
                  setRemark(value);
                  if (value.trim().length < 5) {
                    setRemarkError("Remark must be at least 5 characters.");
                  } else {
                    setRemarkError("");
                  }
                }}
                fullWidth
                required
                error={!!remarkError}
                helperText={remarkError}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleConfirmAction} disabled={sunmitLoading}>
            {sunmitLoading ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              "Submit"
            )}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Form Dialog */}
      <Dialog
        open={openTaskDialog}
        onClose={handleCloseTaskDialog}
        maxWidth="md"
      >
        <DialogTitle
          sx={{
            background: (theme) => theme.palette.primary.main,
            color: "#fff",
          }}
        >
          {typeOfTask} Task
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleCloseTaskDialog}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: "#fff",
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          {(() => {
            if (
              typeOfTask === "Meeting_Office" ||
              typeOfTask === "Meeting_Field" ||
              typeOfTask === "Meeting"
            ) {
              return (
                <>
                  <MeetingFormComponent
                    setShowMeetingForm={setShowMeetingForm}
                    leadDetailsId={leadId}
                    setSeverity={setSeverity}
                    setMessage={setMessage}
                    setOpenSnackbar={setOpenSnackbar}
                    setRunEffect={setRunEffect}
                    setOpenTaskDialog={setOpenTaskDialog}
                    travelDetailsId={travelDetailsId}
                    placeOfSubmit={placeOfSubmit}
                    fetchDailyTasks={fetchDailyTasks}
                    bdmLeadActionId={bdmLeadActionId}
                    typeOfTask={typeOfTask}
                  />
                </>
              );
            } else if (typeOfTask === "Site Visit") {
              return (
                <>
                  <SiteVisitFormComponent
                    setSiteVisitForm={setSiteVisitForm}
                    leadDetailsId={leadId}
                    setSeverity={setSeverity}
                    setMessage={setMessage}
                    setOpenSnackbar={setOpenSnackbar}
                    setRunEffect={setRunEffect}
                    setOpenTaskDialog={setOpenTaskDialog}
                    travelDetailsId={travelDetailsId}
                    placeOfSubmit={placeOfSubmit}
                    fetchDailyTasks={fetchDailyTasks}
                    bdmLeadActionId={bdmLeadActionId}
                  />
                </>
              );
            } else if (typeOfTask === "On Call Discussion") {
              return (
                <>
                  <OnCallFormComponent
                    roleType={"BDM"}
                    setSeverity={setSeverity}
                    setMessage={setMessage}
                    setOpenSnackbar={setOpenSnackbar}
                    setRunEffect={setRunEffect}
                    leadId={leadId}
                    setOpenTaskDialog={setOpenTaskDialog}
                    fetchDailyTasks={fetchDailyTasks}
                    handleCloseFormDialog={handleCloseFormDialog}
                    bdmLeadActionId={bdmLeadActionId}
                  ></OnCallFormComponent>
                </>
              );
            } else if (typeOfTask === "Farm Visit" || typeOfTask === "Head Office Visit") {
              return (
                <>
                  <FarmVisitFormComponent 
                  farmList={farmList}
                  setOpenTaskDialog={setOpenTaskDialog}
                  fetchDailyTasks={fetchDailyTasks}
                    bdmLeadActionId={bdmLeadActionId}
                    setOpenSnackbar={setOpenSnackbar}
                    setMessage={setMessage}
                    setSeverity={setSeverity}></FarmVisitFormComponent>
                </>
              );
            }
          })()}
        </DialogContent>
      </Dialog>

      {/* HO, RO, Travel Form */}
      <Dialog
        open={openVisitFormsDialog}
        onClose={() => {
          setOpenVisitFormsDialog(false);
          handleResetHoForm();
          handleResetRoBoForm();
          handleResetTravelForm();
          setBranchList([]);
          setRoList([]);
        }}
        maxWidth="md"
      >
        <DialogTitle
          sx={{
            background: (theme) => theme.palette.primary.main,
            color: "#fff",
          }}
        >
          {typeOfTask} Task
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={() => {
            setOpenVisitFormsDialog(false);
            handleResetHoForm();
            handleResetRoBoForm();
            handleResetTravelForm();
            setBranchList([]);
            setRoList([]);
            setPreviewUrl(null);
            setPreviewOptionalUrl(null);
          }}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: "#fff",
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          {(() => {
            if (typeOfTask === "BO Visit" || typeOfTask === "RO Visit") {
              return (
                <>
                  <Grid container spacing={2} mb={2}>
                    {typeOfTask === "BO Visit" && (
                      <Grid item xs={12}>
                        <Autocomplete
                          options={branchList}
                          getOptionLabel={(option) => option.label}
                          value={
                            branchList.find((opt) => opt.label === branch) ||
                            null
                          }
                          onOpen={() => {
                            if (!branchList.length) {
                              getBOandROListByBdm(); // Fetch only if list is empty
                            }
                          }}
                          onChange={(event, newValue) => {
                            setBranch(newValue?.label || "");
                            setFormErrors((prev) => ({
                              ...prev,
                              branchName: "",
                            }));
                          }}
                          loading={branchLoading}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Select Branch Name"
                              fullWidth
                              required
                              error={!!formErrors.branchName}
                              helperText={formErrors.branchName}
                              InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                  <>
                                    {branchLoading && (
                                      <CircularProgress
                                        color="inherit"
                                        size={20}
                                      />
                                    )}
                                    {params.InputProps.endAdornment}
                                  </>
                                ),
                              }}
                            />
                          )}
                        />
                      </Grid>
                    )}

                    {typeOfTask === "RO Visit" && (
                      <Grid item xs={12}>
                        <Autocomplete
                          options={roList}
                          getOptionLabel={(option) => option.label}
                          value={
                            roList.find(
                              (opt) => opt.label === regionalOffice
                            ) || null
                          }
                          onOpen={() => {
                            if (!roList.length) {
                              getBOandROListByBdm(); // Fetch only if list is empty
                            }
                          }}
                          onChange={(event, newValue) => {
                            setRegionalOffice(newValue?.label || "");
                            setFormErrors((prev) => ({
                              ...prev,
                              regionalOfficeName: "",
                            }));
                          }}
                          loading={branchLoading}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Select RO Name"
                              fullWidth
                              required
                              error={!!formErrors.regionalOfficeName}
                              helperText={formErrors.regionalOfficeName}
                              InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                  <>
                                    {branchLoading && (
                                      <CircularProgress
                                        color="inherit"
                                        size={20}
                                      />
                                    )}
                                    {params.InputProps.endAdornment}
                                  </>
                                ),
                              }}
                            />
                          )}
                        />
                      </Grid>
                    )}

                    <Grid item xs={12}>
                      <Select
                        fullWidth
                        displayEmpty
                        value={selection}
                        onChange={(e) => {
                          setSelection(e.target.value);
                          setFormErrors((prev) => ({
                            ...prev,
                            purposeForVisit: "",
                          }));
                        }}
                      >
                        <MenuItem value="">-- Select --</MenuItem>
                        <MenuItem value="Meeting_with_RH_BM_ZH">
                          Meeting with RH/BM/ZH
                        </MenuItem>
                        <MenuItem value="Admin_Work">Admin Work</MenuItem>
                        <MenuItem value="customer_meeting">Customer Meeting</MenuItem>
                        <MenuItem value="other">Other</MenuItem>
                      </Select>
                      {formErrors.purposeForVisit && (
                        <FormHelperText>
                          <span style={{ color: "red" }}>
                            {formErrors.purposeForVisit}
                          </span>
                        </FormHelperText>
                      )}
                    </Grid>

                    {/* Meeting with RH/BM/ZH Section */}
                    {selection === "Meeting_with_RH_BM_ZH" && (
                      <Grid item xs={12}>
                        <TextField
                          label="Name of Concern Person"
                          fullWidth
                          value={concernPerson}
                          onChange={(e) => setConcernPerson(e.target.value)}
                          required
                          error={!!formErrors.concernPersonName}
                          helperText={formErrors.concernPersonName}
                          InputProps={{
                            inputProps: {
                              maxLength: 50, // Pincode should be 6 digits max
                            },
                          }}
                        />
                      </Grid>
                    )}

                    {/* Admin Work Section */}
                    {selection === "Admin_Work" && (
                      <>
                        <Grid item xs={12}>
                          <Select
                            fullWidth
                            value={adminTask}
                            onChange={(e) => {
                              setAdminTask(e.target.value);
                              setFormErrors((prev) => ({
                                ...prev,
                                adminTaskSelect: "",
                              }));
                            }}
                            displayEmpty
                          >
                            <MenuItem value="">
                              -- Select Admin Task --
                            </MenuItem>
                            <MenuItem value="Agreement">Agreement</MenuItem>
                            <MenuItem value="Customer_KYC">
                              Customer KYC
                            </MenuItem>
                            <MenuItem value="Others">Others</MenuItem>
                          </Select>
                          {formErrors.adminTaskSelect && (
                            <FormHelperText>
                              <span style={{ color: "red" }}>
                                {formErrors.adminTaskSelect}
                              </span>
                            </FormHelperText>
                          )}
                        </Grid>
                      </>
                    )}

                    <Grid item xs={12}>
                      <TextField
                        label="Remark"
                        multiline
                        rows={3}
                        fullWidth
                        value={othersRemark}
                        onChange={(e) => {
                          setOthersRemark(e.target.value);
                          setFormErrors((prev) => ({ ...prev, remarks: "" }));
                        }}
                        error={!!formErrors.remarks}
                        helperText={formErrors.remarks}
                        required
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <Typography variant="subtitle1" gutterBottom>
                        Upload Visit Pictures
                      </Typography>
                    </Grid>

                    {/* Mandatory Visit Picture */}
                    <Grid item xs={12}>
                      <Button
                        variant="outlined"
                        component="label"
                        fullWidth
                        disabled={loadingMandatory}
                        sx={{
                          width: "60%",
                          marginTop: "8px",
                          textTransform: "none",
                          border: "2px dashed black",
                          backgroundColor: "lightgray",
                          "&:hover": {
                            backgroundColor: "gray",
                          },
                          cursor: loadingMandatory ? "not-allowed" : "pointer",
                          opacity: 1,
                        }}
                      >
                        {loadingMandatory ? (
                          <CircularProgress size={20} sx={{ mr: 1 }} />
                        ) : (
                          "Upload Visit Image1"
                        )}
                        <span style={{ color: "red", marginLeft: "4px" }}>
                          *
                        </span>
                        <input
                          type="file"
                          accept="image/*"
                          hidden
                          required
                          onChange={(e) =>
                            handleImageUpload(
                              e,
                              setVisitPictureMandatory,
                              setPreviewUrl,
                              true,
                              setLoadingMandatory
                            )
                          }
                        />
                      </Button>
                      {visitPictureMandatory && !loadingMandatory && (
                        <>
                          <Typography variant="body2" mt={1}>
                            {visitPictureMandatory.name}
                          </Typography>
                          {previewUrl && (
                            <Box
                              mt={1}
                              position="relative"
                              display="inline-block"
                            >
                              <img
                                src={previewUrl}
                                alt="Preview 1"
                                style={{
                                  maxWidth: "100%",
                                  maxHeight: "200px",
                                  borderRadius: "8px",
                                  marginTop: "8px",
                                  border: "1px solid #ccc",
                                }}
                              />
                              <IconButton
                                size="small"
                                onClick={() => {
                                  setVisitPictureMandatory(null);
                                  setPreviewUrl("");
                                }}
                                sx={{
                                  position: "absolute",
                                  top: 5,
                                  right: 4,
                                  backgroundColor: "white",
                                  "&:hover": { backgroundColor: "#f8d7da" },
                                }}
                              >
                                <DeleteIcon fontSize="small" color="error" />
                              </IconButton>
                            </Box>
                          )}
                        </>
                      )}
                      {formErrors.mandatoryVisitImage && (
                        <FormHelperText>
                          <span style={{ color: "red" }}>
                            {formErrors.mandatoryVisitImage}
                          </span>
                        </FormHelperText>
                      )}
                    </Grid>

                    {/* Optional Visit Picture */}
                    <Grid item xs={12}>
                      <Button
                        variant="outlined"
                        component="label"
                        fullWidth
                        disabled={loadingOptional}
                        sx={{
                          width: "60%",
                          marginTop: "8px",
                          textTransform: "none",
                          border: "2px dashed black",
                          backgroundColor: "lightgray",
                          "&:hover": {
                            backgroundColor: "gray",
                          },
                          cursor: loadingOptional ? "not-allowed" : "pointer",
                          opacity: 1,
                        }}
                      >
                        {loadingOptional ? (
                          <CircularProgress size={20} sx={{ mr: 1 }} />
                        ) : (
                          "Upload Visit Image2"
                        )}
                        <input
                          type="file"
                          accept="image/*"
                          hidden
                          onChange={(e) =>
                            handleImageUpload(
                              e,
                              setVisitPictureOptional,
                              setPreviewOptionalUrl,
                              false,
                              setLoadingOptional
                            )
                          }
                        />
                      </Button>
                      {visitPictureOptional && !loadingOptional && (
                        <>
                          <Typography variant="body2" mt={1}>
                            {visitPictureOptional.name}
                          </Typography>
                          {previewOptionalUrl && (
                            <Box
                              mt={1}
                              position="relative"
                              display="inline-block"
                            >
                              <img
                                src={previewOptionalUrl}
                                alt="Preview 2"
                                style={{
                                  maxWidth: "100%",
                                  maxHeight: "200px",
                                  borderRadius: "8px",
                                  marginTop: "8px",
                                  border: "1px solid #ccc",
                                }}
                              />
                              <IconButton
                                size="small"
                                onClick={() => {
                                  setVisitPictureOptional(null);
                                  setPreviewOptionalUrl("");
                                }}
                                sx={{
                                  position: "absolute",
                                  top: 5,
                                  right: 4,
                                  backgroundColor: "white",
                                  "&:hover": { backgroundColor: "#f8d7da" },
                                }}
                              >
                                <DeleteIcon fontSize="small" color="error" />
                              </IconButton>
                            </Box>
                          )}
                        </>
                      )}
                    </Grid>

                    <Grid item xs={12}>
                      <Button
                        variant="contained"
                        onClick={handleROorBOVisitSubmit}
                        disabled={isRoBoFormSubmitting}
                        startIcon={
                          isRoBoFormSubmitting ? (
                            <CircularProgress size={20} color="inherit" />
                          ) : null
                        }
                      >
                        {isRoBoFormSubmitting ? "Submitting..." : "Submit"}
                      </Button>
                    </Grid>
                  </Grid>
                </>
              );
            } else if (typeOfTask === "HO Visit") {
              return (
                <>
                  <Grid container spacing={2} mb={2}>
                    <Grid item xs={12}>
                      <FormControl fullWidth error={!!formErrors.hoSelection}>
                        <Select
                          fullWidth
                          displayEmpty
                          value={hoSelection}
                          onChange={(e) => {
                            setHoSelection(e.target.value);
                            setFormErrors((prev) => ({
                              ...prev,
                              hoSelection: "",
                            }));
                          }}
                        >
                          <MenuItem value="">-- Select --</MenuItem>
                          <MenuItem value="Training">Training</MenuItem>
                          <MenuItem value="Review">Review</MenuItem>
                          <MenuItem value="Other">Others</MenuItem>
                        </Select>
                        {formErrors.hoSelection && (
                          <FormHelperText>
                            {formErrors.hoSelection}
                          </FormHelperText>
                        )}
                      </FormControl>
                    </Grid>

                    <Grid item xs={12}>
                      <TextField
                        label="Remark"
                        multiline
                        rows={3}
                        fullWidth
                        sx={{ mt: 2 }}
                        value={othersRemark}
                        onChange={(e) => {
                          setOthersRemark(e.target.value);
                          setFormErrors((prev) => ({ ...prev, remarks: "" }));
                        }}
                        required
                        error={!!formErrors.remarks}
                        helperText={formErrors.remarks}
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <Typography variant="subtitle1" gutterBottom>
                        Upload Visit Pictures
                      </Typography>
                    </Grid>

                    {/* Mandatory Visit Image 1 */}
                    <Grid item xs={12}>
                      <Button
                        variant="outlined"
                        component="label"
                        fullWidth
                        disabled={loadingMandatory}
                        sx={{
                          width: "60%",
                          marginTop: "8px",
                          textTransform: "none",
                          border: "2px dashed black",
                          backgroundColor: "lightgray",
                          "&:hover": {
                            backgroundColor: "gray",
                          },
                          cursor: loadingMandatory ? "not-allowed" : "pointer",
                          opacity: 1,
                        }}
                      >
                        {loadingMandatory ? (
                          <>
                            <CircularProgress size={20} sx={{ mr: 1 }} />
                            Compressing...
                          </>
                        ) : (
                          <>
                            Upload Visit Image1{" "}
                            <span style={{ color: "red" }}>*</span>
                          </>
                        )}
                        <input
                          type="file"
                          accept="image/*"
                          hidden
                          required
                          onChange={(e) =>
                            handleImageUpload(
                              e,
                              setHoVisitPictureMandatory,
                              setPreviewUrl,
                              true,
                              setLoadingMandatory
                            )
                          }
                        />
                      </Button>
                      {hoVisitPictureMandatory && !loadingMandatory && (
                        <>
                          <Typography variant="body2" mt={1}>
                            {hoVisitPictureMandatory.name}
                          </Typography>
                          {previewUrl && (
                            <Box
                              mt={1}
                              position="relative"
                              display="inline-block"
                            >
                              <img
                                src={previewUrl}
                                alt="Visit Preview 1"
                                style={{
                                  maxWidth: "100%",
                                  maxHeight: "200px",
                                  borderRadius: "8px",
                                  marginTop: "8px",
                                  border: "1px solid #ccc",
                                }}
                              />
                              <IconButton
                                size="small"
                                onClick={() => {
                                  setHoVisitPictureMandatory(null);
                                  setPreviewUrl("");
                                }}
                                sx={{
                                  position: "absolute",
                                  top: 5,
                                  right: 4,
                                  backgroundColor: "white",
                                  "&:hover": { backgroundColor: "#f8d7da" },
                                }}
                              >
                                <DeleteIcon fontSize="small" color="error" />
                              </IconButton>
                            </Box>
                          )}
                        </>
                      )}
                      {formErrors.mandatoryVisitImage && (
                        <FormHelperText>
                          <span style={{ color: "red" }}>
                            {formErrors.mandatoryVisitImage}
                          </span>
                        </FormHelperText>
                      )}
                    </Grid>

                    {/* Optional Visit Image 2 */}
                    <Grid item xs={12}>
                      <Button
                        variant="outlined"
                        component="label"
                        fullWidth
                        disabled={loadingOptional}
                        sx={{
                          width: "60%",
                          marginTop: "8px",
                          textTransform: "none",
                          border: "2px dashed black",
                          backgroundColor: "lightgray",
                          "&:hover": {
                            backgroundColor: "gray",
                          },
                          cursor: loadingOptional ? "not-allowed" : "pointer",
                          opacity: 1,
                        }}
                      >
                        {loadingOptional ? (
                          <>
                            <CircularProgress size={20} sx={{ mr: 1 }} />
                            Compressing...
                          </>
                        ) : (
                          "Upload Visit Image2"
                        )}
                        <input
                          type="file"
                          accept="image/*"
                          hidden
                          onChange={(e) =>
                            handleImageUpload(
                              e,
                              setHoVisitPictureOptional,
                              setPreviewOptionalUrl,
                              false,
                              setLoadingOptional
                            )
                          }
                        />
                      </Button>
                      {hoVisitPictureOptional && !loadingOptional && (
                        <>
                          <Typography variant="body2" mt={1}>
                            {hoVisitPictureOptional.name}
                          </Typography>
                          {previewOptionalUrl && (
                            <Box
                              mt={1}
                              position="relative"
                              display="inline-block"
                            >
                              <img
                                src={previewOptionalUrl}
                                alt="Visit Preview 2"
                                style={{
                                  maxWidth: "100%",
                                  maxHeight: "200px",
                                  borderRadius: "8px",
                                  marginTop: "8px",
                                  border: "1px solid #ccc",
                                }}
                              />
                              <IconButton
                                size="small"
                                onClick={() => {
                                  setHoVisitPictureOptional(null);
                                  setPreviewOptionalUrl("");
                                }}
                                sx={{
                                  position: "absolute",
                                  top: 5,
                                  right: 4,
                                  backgroundColor: "white",
                                  "&:hover": { backgroundColor: "#f8d7da" },
                                }}
                              >
                                <DeleteIcon fontSize="small" color="error" />
                              </IconButton>
                            </Box>
                          )}
                        </>
                      )}
                    </Grid>

                    <Grid item xs={12}>
                      <Button
                        variant="contained"
                        onClick={handleSubmitHoTask}
                        disabled={isHoFormSubmitting}
                        startIcon={
                          isHoFormSubmitting ? (
                            <CircularProgress size={20} color="inherit" />
                          ) : null
                        }
                      >
                        {isHoFormSubmitting ? "Submitting..." : "Submit"}
                      </Button>
                    </Grid>
                  </Grid>
                </>
              );
            } else if (typeOfTask === "Travel") {
              return (
                <>
                  <Grid container spacing={2} mb={2}>
                    <Grid item xs={12}>
                      <FormControl fullWidth error={!!formErrors.modeOfTravel}>
                        <Select
                          fullWidth
                          displayEmpty
                          value={travelSelection}
                          onChange={(e) => {
                            setTravelSelection(e.target.value);
                            setFormErrors((prev) => ({
                              ...prev,
                              modeOfTravel: "",
                            }));
                          }}
                          required
                        >
                          <MenuItem value="">-- Select --</MenuItem>
                          <MenuItem value="car">Car</MenuItem>
                          <MenuItem value="bike">Bike/Scooter</MenuItem>
                          <MenuItem value="bus">Bus</MenuItem>
                          <MenuItem value="train">Train</MenuItem>
                          <MenuItem value="air">Flight</MenuItem>
                          <MenuItem value="auto">Auto</MenuItem>
                        </Select>
                        {formErrors.modeOfTravel && (
                          <FormHelperText>
                            {formErrors.modeOfTravel}
                          </FormHelperText>
                        )}
                      </FormControl>
                    </Grid>

                    <Grid item xs={12}>
                      <FormControl
                        fullWidth
                        error={!!formErrors.reasonForTravel}
                      >
                        <Select
                          fullWidth
                          displayEmpty
                          value={reasonForTravel}
                          onChange={(e) => {
                            setReasonForTravel(e.target.value);
                            setFormErrors((prev) => ({
                              ...prev,
                              reasonForTravel: "",
                            }));
                          }}
                          required
                        >
                          <MenuItem value="">-- Select Reason --</MenuItem>
                          <MenuItem value="New Area Development">
                            New Area Development
                          </MenuItem>
                          <MenuItem value="Customer Meeting">
                            Customer Meeting
                          </MenuItem>
                          <MenuItem value="BO Meeting">BO Meeting</MenuItem>
                          <MenuItem value="RO Meeting">RO Meeting</MenuItem>
                          <MenuItem value="HO Meeting">HO Meeting</MenuItem>
                          <MenuItem value="Site Visit">Site Visit</MenuItem>
                          <MenuItem value="Travel Back to Base Location">
                            Travel Back to Base Location
                          </MenuItem>
                        </Select>
                        {formErrors.reasonForTravel && (
                          <FormHelperText>
                            {formErrors.reasonForTravel}
                          </FormHelperText>
                        )}
                      </FormControl>
                    </Grid>

                    <Grid item xs={12}>
                      <Grid container spacing={1} alignItems="center">
                        <Grid item xs>
                          <TextField
                            label="From"
                            fullWidth
                            value={fromLocation}
                            onChange={(e) => {
                              const upper = e.target.value.toUpperCase();
                              setFromLocation(upper);
                              setFormErrors((prev) => ({
                                ...prev,
                                travelFrom: "",
                              }));
                            }}
                            error={!!formErrors.travelFrom}
                            helperText={formErrors.travelFrom}
                            required
                            sx={{ textTransform: "uppercase" }}
                          />
                        </Grid>
                        {/* <Grid item>
                          <IconButton
                            onClick={() => {
                              setDialogType("from");
                              setSelectedDistrict(fromLocation);
                              setLeadConfirmDialog(true);
                            }}
                          >
                            <SearchIcon />
                          </IconButton>
                        </Grid> */}
                      </Grid>
                    </Grid>

                    <Grid item xs={12}>
                      <Grid container spacing={1} alignItems="center">
                        <Grid item xs>
                          <TextField
                            label="To"
                            fullWidth
                            value={toLocation}
                            onChange={(e) => {
                              const upper = e.target.value.toUpperCase();
                              setToLocation(upper);
                              setFormErrors((prev) => ({
                                ...prev,
                                travelTo: "",
                              }));
                            }}
                            error={!!formErrors.travelTo}
                            helperText={formErrors.travelTo}
                            required
                            sx={{ textTransform: "uppercase" }}
                          />
                        </Grid>
                        {/* <Grid item>
                          <IconButton
                            onClick={() => {
                              setDialogType("to");
                              setSelectedDistrict(toLocation);
                              setLeadConfirmDialog(true);
                            }}
                          >
                            <SearchIcon />
                          </IconButton>
                        </Grid> */}
                      </Grid>
                    </Grid>

                    {/* <Grid item xs={12}>
                      <TextField
                        label="Select Nearest Branch"
                        fullWidth
                        value={nearestBranch}
                        onChange={(e) => setNearestBranch(e.target.value)}
                      />
                    </Grid> */}

                    <Grid item xs={12}>
                      <TextField
                        label="Remark"
                        multiline
                        rows={3}
                        fullWidth
                        sx={{ mt: 2 }}
                        value={travelRemark}
                        onChange={(e) => {
                          setTravelRemark(e.target.value);
                          setFormErrors((prev) => ({ ...prev, remarks: "" }));
                        }}
                        error={!!formErrors.remarks}
                        helperText={formErrors.remarks}
                        required
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <Typography variant="subtitle1" gutterBottom>
                        Upload Visit Pictures
                      </Typography>
                    </Grid>

                    {/* Mandatory Visit Picture */}
                    <Grid item xs={12}>
                      <Button
                        variant="outlined"
                        component="label"
                        fullWidth
                        disabled={loadingMandatory}
                        sx={{
                          width: "60%",
                          mt: 1,
                          textTransform: "none",
                          border: "2px dashed black",
                          backgroundColor: "lightgray",
                          "&:hover": { backgroundColor: "gray" },
                          cursor: "pointer",
                          opacity: 1,
                        }}
                      >
                        {loadingMandatory
                          ? "Uploading..."
                          : "Upload Visit Image1"}{" "}
                        <span style={{ color: "red" }}>*</span>
                        <input
                          type="file"
                          accept="image/*"
                          hidden
                          required
                          onChange={async (e) => {
                            const file = e.target.files[0];
                            if (file) {
                              setLoadingMandatory(true);
                              try {
                                const compressedFile = await imageCompression(
                                  file,
                                  {
                                    maxSizeMB: 2,
                                    maxWidthOrHeight: 1024,
                                    useWebWorker: true,
                                  }
                                );

                                const extension = file.name.split(".").pop();
                                const uniqueName = `img_${Date.now()}.${extension}`;
                                const finalFile = new File(
                                  [compressedFile],
                                  uniqueName,
                                  {
                                    type: compressedFile.type,
                                    lastModified: Date.now(),
                                  }
                                );

                                setTravelPictureMandatory(finalFile);
                                setFormErrors((prev) => ({
                                  ...prev,
                                  mandatoryVisitImage: "",
                                }));

                                setPreviewUrl(URL.createObjectURL(finalFile));
                              } catch (error) {
                                console.error(
                                  "Image compression failed:",
                                  error
                                );
                              } finally {
                                setLoadingMandatory(false);
                              }
                            }
                          }}
                        />
                      </Button>

                      {travelPictureMandatory && (
                        <>
                          <Typography variant="body2" mt={1}>
                            {travelPictureMandatory.name}
                          </Typography>
                          {previewUrl && (
                            <Box
                              mt={1}
                              position="relative"
                              display="inline-block"
                            >
                              <img
                                src={previewUrl}
                                alt="Visit Preview"
                                style={{
                                  maxWidth: "100%",
                                  maxHeight: "200px",
                                  borderRadius: "8px",
                                  marginTop: "8px",
                                  border: "1px solid #ccc",
                                }}
                              />
                              <IconButton
                                size="small"
                                onClick={() => {
                                  setTravelPictureMandatory(null);
                                  setPreviewUrl("");
                                }}
                                sx={{
                                  position: "absolute",
                                  top: 4,
                                  right: 4,
                                  backgroundColor: "white",
                                  "&:hover": { backgroundColor: "#f8d7da" },
                                }}
                              >
                                <DeleteIcon fontSize="small" color="error" />
                              </IconButton>
                            </Box>
                          )}
                        </>
                      )}

                      {formErrors.mandatoryVisitImage && (
                        <FormHelperText>
                          <span style={{ color: "red" }}>
                            {formErrors.mandatoryVisitImage}
                          </span>
                        </FormHelperText>
                      )}
                    </Grid>

                    {/* Optional Visit Picture */}
                    <Grid item xs={12}>
                      <Button
                        variant="outlined"
                        component="label"
                        fullWidth
                        disabled={loadingOptional}
                        sx={{
                          width: "60%",
                          mt: 1,
                          textTransform: "none",
                          border: "2px dashed black",
                          backgroundColor: "lightgray",
                          "&:hover": { backgroundColor: "gray" },
                          cursor: "pointer",
                          opacity: 1,
                        }}
                      >
                        {loadingOptional
                          ? "Uploading..."
                          : "Upload Visit Image2"}
                        <input
                          type="file"
                          accept="image/*"
                          hidden
                          onChange={async (e) => {
                            const file = e.target.files[0];
                            if (file) {
                              setLoadingOptional(true);
                              try {
                                const compressedFile = await imageCompression(
                                  file,
                                  {
                                    maxSizeMB: 2,
                                    maxWidthOrHeight: 1024,
                                    useWebWorker: true,
                                  }
                                );

                                const extension = file.name.split(".").pop();
                                const uniqueName = `img_${Date.now()}.${extension}`;
                                const finalFile = new File(
                                  [compressedFile],
                                  uniqueName,
                                  {
                                    type: compressedFile.type,
                                    lastModified: Date.now(),
                                  }
                                );

                                setTravelPictureOptional(finalFile);
                                setPreviewOptionalUrl(
                                  URL.createObjectURL(finalFile)
                                );
                              } catch (err) {
                                console.error("Image compression failed:", err);
                              } finally {
                                setLoadingOptional(false);
                              }
                            }
                          }}
                        />
                      </Button>

                      {travelPictureOptional && (
                        <>
                          <Typography variant="body2" mt={1}>
                            {travelPictureOptional.name}
                          </Typography>
                          {previewOptionalUrl && (
                            <Box
                              mt={1}
                              position="relative"
                              display="inline-block"
                            >
                              <img
                                src={previewOptionalUrl}
                                alt="Visit Preview 2"
                                style={{
                                  maxWidth: "100%",
                                  maxHeight: "200px",
                                  borderRadius: "8px",
                                  marginTop: "8px",
                                  border: "1px solid #ccc",
                                }}
                              />
                              <IconButton
                                size="small"
                                onClick={() => {
                                  setTravelPictureOptional(null);
                                  setPreviewOptionalUrl("");
                                }}
                                sx={{
                                  position: "absolute",
                                  top: 4,
                                  right: 4,
                                  backgroundColor: "white",
                                  "&:hover": { backgroundColor: "#f8d7da" },
                                }}
                              >
                                <DeleteIcon fontSize="small" color="error" />
                              </IconButton>
                            </Box>
                          )}
                        </>
                      )}
                    </Grid>

                    <Grid item xs={12}>
                      <Button
                        variant="contained"
                        onClick={handleTravelFormSubmit}
                        disabled={isTravelSubmitting}
                        startIcon={
                          isTravelSubmitting ? (
                            <CircularProgress size={20} color="inherit" />
                          ) : null
                        }
                      >
                        {isTravelSubmitting ? "Submitting..." : "Submit"}
                      </Button>
                    </Grid>
                  </Grid>
                </>
              );
            }
          })()}
        </DialogContent>
      </Dialog>

      {/* Alert for user to confirm before adding new lead */}
      <Dialog
        open={leadConfirmDialog}
        onClose={() => setLeadConfirmDialog(false)}
      >
        <DialogTitle></DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={12}>
              <TextField
                label="Pincode"
                fullWidth
                value={pincode}
                onChange={(e) => {
                  const value = e.target.value;
                  setPincode(value);
                  if (value.length === 6) {
                    fetchPincodeData(value);
                  }
                }}
                InputProps={{
                  inputProps: {
                    maxLength: 6, // Pincode should be 6 digits max
                    inputMode: "numeric", // Optimized for mobile numeric input
                  },
                  endAdornment: pincodeLoading ? (
                    <InputAdornment position="end">
                      <CircularProgress size={20} />
                    </InputAdornment>
                  ) : null,
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Autocomplete
                options={locationList}
                value={selectedDistrict}
                onChange={(e, newValue) => setSelectedDistrict(newValue)}
                getOptionLabel={(option) => option?.names || ""}
                renderInput={(params) => (
                  <TextField {...params} label="Select District" fullWidth />
                )}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setPincode("");
              setSelectedDistrict("");
              setLeadConfirmDialog(false);
              setLocationList([]);
            }}
            color="secondary"
          >
            Cancel
          </Button>
          <Button
            onClick={() => {
              console.log(selectedDistrict);

              if (dialogType === "from") {
                setFromLocation(selectedDistrict.names);
                setFormErrors((prev) => ({ ...prev, travelFrom: "" }));
              } else if (dialogType === "to") {
                setToLocation(selectedDistrict.names);
                setFormErrors((prev) => ({ ...prev, travelTo: "" }));
              }
              setPincode("");
              setSelectedDistrict("");
              setLeadConfirmDialog(false);
              setLocationList([]);
            }}
            color="primary"
            variant="contained"
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openImageDialog}
        onClose={() => setOpenImageDialog(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogContent
          sx={{ p: 0, position: "relative", backgroundColor: "black" }}
        >
          {/* Close Button */}
          <IconButton
            aria-label="close"
            onClick={() => {
              setOpenImageDialog(false);
              setSelectedImage(null);
            }}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: "#fff",
              zIndex: 1,
            }}
          >
            <CloseIcon />
          </IconButton>

          {/* Image */}
          <img
            src={selectedImage}
            alt="Visit"
            style={{ width: "100%", height: "auto", display: "block" }}
          />
        </DialogContent>
      </Dialog>

      {/* Add Lead Modal */}
      <ModalComponent
        open={open}
        modalTitle={"BDM Lead Generation"}
        setOpen={setOpen}
        rowDetails={{}}
        setOpenSnackbar={setOpenSnackbar}
        setSeverity={setSeverity}
        setMessage={setMessage}
        setEditMobNo={setEditMobNo}
        leadNumber={leadNumber}
        afterLeadCreatedCallback={afterLeadCreatedCallback}
      ></ModalComponent>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000} // Snackbar will auto hide after 6 seconds
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={severity}
          sx={{ width: "100%" }}
        >
          {message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default BdmToDoPage;
